/**
 * Shopify Essence Match Quiz
 * Updated with New Content and Text Structure
 */

class QuizAnalytics {
  constructor() {
    this.startTime = null;
    this.stepStartTimes = {};
    this.stepResponses = {};
    this.userAge = null;
    this.sessionId = this.generateSessionId();
    this.skipCount = 0;
    this.backNavigationCount = 0;
    this.scrollDepthMaxPercent = 0;
    this.productViews = {};

  }

  generateSessionId() {
    return 'quiz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  initializeTracking() {
    if (typeof window.dataLayer === 'undefined') {

      return false;
    }
    
    this.startTime = Date.now();
    this.stepStartTimes[1] = Date.now();
    
    window.dataLayer.push({
      'event': 'quiz_started',
      'event_category': 'Quiz_Engagement',
      'event_label': 'Essence_Match_Quiz',
      'quiz_session_id': this.sessionId,
      'quiz_type': 'essence_match'
    });

    return true;
  }
  
  
  trackUserInfo(userData) {
    if (!userData || !userData.firstName) {

      return;
    }
  
    try { 
      
      if (typeof window.dataLayer === 'undefined') {

        return;
      }
  
      window.dataLayer.push({
        'quiz_session_id': this.sessionId,
        'quiz_session_id': this.sessionId,
        'event': 'quiz_user_info_collected',
      });
  
    } catch (error) {

    }
  }
  
  trackStepChange(fromStep, toStep, response = null) {
    const now = Date.now();
    
    if (this.stepStartTimes[fromStep]) {
      const timeSpent = now - this.stepStartTimes[fromStep];
      
      window.dataLayer.push({
        'event': 'quiz_step_time',
        'event_category': 'Quiz_Timing',
        'event_label': `Step_${fromStep}_Time`,
        'quiz_session_id': this.sessionId,
        'step_number': fromStep,
        'time_spent_seconds': Math.round(timeSpent / 1000),
        'time_category': this.getTimeCategory(Math.round(timeSpent / 1000))
      });

    }
  
    if (response) {
      this.stepResponses[fromStep] = response;
      
      window.dataLayer.push({
        'event': 'quiz_question_answered',
        'event_category': 'Quiz_Responses',
        'event_label': `Step_${fromStep}_${response}`,
        'quiz_session_id': this.sessionId,
        'step_number': fromStep,
        'answer_value': response,
        'question_type': this.getQuestionType(fromStep),
      //  'user_age_group': this.getAgeGroup(this.userAge)
      });

    }
  
    if (toStep > fromStep) {
      window.dataLayer.push({
        'event': 'quiz_step_completed',
        'event_category': 'Quiz_Progress',
        'event_label': `Step_${fromStep}_Completed`,
        'quiz_session_id': this.sessionId,
        'step_number': fromStep,
        'progress_percentage': Math.round((fromStep / 9) * 100)
      });

    }
  
    this.stepStartTimes[toStep] = now;

  }

  trackProductView(productId, productTitle, essence, position) {
    if (!this.productViews[productId]) {
      this.productViews[productId] = 0;
    }
    this.productViews[productId]++;
  
    window.dataLayer.push({
      'event': 'quiz_product_view',
      'event_category': 'Quiz_Product_Engagement',
      'event_label': `Product_View_${essence}`,
      'quiz_session_id': this.sessionId,
      'product_id': productId,
      'product_title': productTitle,
      'essence_type': essence,
      'position_in_slider': position,
      'view_count': this.productViews[productId],
    //  'user_age_group': this.getAgeGroup(this.userAge)
    });
  }
  
  trackQuickView(productId, productTitle, essence) {
    window.dataLayer.push({
      'event': 'quiz_quick_view',
      'event_category': 'Quiz_Product_Engagement',
      'event_label': `Quick_View_${essence}`,
      'quiz_session_id': this.sessionId,
      'product_id': productId,
      'product_title': productTitle,
      'essence_type': essence,
   //   'user_age_group': this.getAgeGroup(this.userAge)
    });
  }
  
  trackAddToCart(productId, productTitle, essence, price) {
    window.dataLayer.push({
      'event': 'quiz_add_to_cart',
      'event_category': 'Quiz_Conversion',
      'event_label': `Add_To_Cart_${essence}`,
      'quiz_session_id': this.sessionId,
      'product_id': productId,
      'product_title': productTitle,
      'essence_type': essence,
      'product_price': price,
  //    'user_age_group': this.getAgeGroup(this.userAge),
      'currency': 'GBP'
    });
  }
 
  trackScrollDepth(percentage) {
    if (percentage > this.scrollDepthMaxPercent) {
      this.scrollDepthMaxPercent = percentage;
      
      const milestones = [25, 50, 75, 90, 100];
      const milestone = milestones.find(m => percentage >= m && this.scrollDepthMaxPercent < m);
      
      if (milestone) {
        window.dataLayer.push({
          'event': 'quiz_results_scroll_depth',
          'event_category': 'Quiz_Results_Engagement',
          'event_label': `Scroll_${milestone}_Percent`,
          'quiz_session_id': this.sessionId,
          'scroll_percentage': milestone,
    //      'user_age_group': this.getAgeGroup(this.userAge)
        });
      }
    }
  }
  
  trackCompletion(results) {
    const totalTime = Date.now() - this.startTime;
    const completionTime = Math.round(totalTime / 1000);
    
    window.dataLayer.push({
      'event': 'quiz_completed',
      'event_category': 'Quiz_Completion',
      'event_label': 'Essence_Match_Quiz_Completed',
      'quiz_session_id': this.sessionId,
      'total_time_seconds': completionTime,
  //    'user_age': this.userAge || 'unknown',
  //    'user_age_group': this.getAgeGroup(this.userAge),
      'quiz_result': results.quiz_result || 'unknown',
      'essence_combination': results.essence_combination || 'unknown',
      'completion_time_category': this.getTimeCategory(completionTime)
    });
  
    if (results.essence_combination) {
      window.dataLayer.push({
      //  'event': 'essence_age_distribution',
        'event_category': 'Quiz_Results_Analysis',
      //  'event_label': `${results.essence_combination}_Age_${this.getAgeGroup(this.userAge)}`,
        'quiz_session_id': this.sessionId,
        'essence_combination': results.essence_combination,
   //     'user_age_group': this.getAgeGroup(this.userAge),
    //    'user_age': this.userAge || 'unknown'
      });
    }
  }

  startResultsPageTracking() {
    this.resultsPageStartTime = Date.now();
    
    window.dataLayer.push({
      'event': 'results_page_started',
      'event_category': 'Quiz_Results_Timing',
      'event_label': 'Results_Page_View',
      'quiz_session_id': this.sessionId,
 //     'user_age_group': this.getAgeGroup(this.userAge)
    });
  }
  
  trackDropoff(currentStep, reason = 'unknown') {
    const totalTime = Date.now() - this.startTime;
    
    window.dataLayer.push({
      'event': 'quiz_abandoned',
      'event_category': 'Quiz_Abandonment',
      'event_label': `Dropped_Step_${currentStep}`,
      'quiz_session_id': this.sessionId,
      'abandoned_step': currentStep,
      'abandonment_reason': reason,
      'progress_percentage': Math.round((currentStep / 9) * 100),
    });
  }

  getQuestionType(step) {
    const questionTypes = {
      2: 'text_choice',
      3: 'image_choice', 
      4: 'image_choice',
      5: 'product_choice',
      6: 'text_choice',
      7: 'text_choice',
      8: 'image_choice',
      9: 'text_choice'
    };
    return questionTypes[step] || 'unknown';
  }

  getTimeCategory(seconds) {
    if (seconds < 60) return 'very_fast';
    if (seconds < 120) return 'fast';
    if (seconds < 300) return 'normal';
    if (seconds < 600) return 'slow';
    return 'very_slow';
  }
}

class EssenceQuiz {
  constructor() {
    this.quizElement = document.getElementById('essence-quiz');
    this.progressBar = null;
    this.progressText = null;
    this.totalSteps = 10;
    this.currentStep = 1;
    this.scores = {
      passion: 0,
      confidence: 0,
      serenity: 0,
      timeless_elegance: 0
    };
    this.essenceDescriptions = {
      confidence: {
        name: "CONFIDENCE",
        color: "#6B5756",
        topRightText: "THERE'S SOMETHING<br>CAPTIVATING ABOUT<br>YOUR PRESENCE",
        mainDescription: "Her presence speaks<br>louder than words",
        singleResult: {
          leftImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/image-essence-left.jpg",
          rightImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/right-column.jpg",
          textTopLeft: "She doesn't raise her voice. She doesn't need to. Her presence says everything.",
          textCenterCenter: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear.",
          textBottomRight: "She leads herself first. She knows. She moves. She owns the moment."
        },
        sheIsTraits: "HER PRESENCE SPEAKS<br>LOUDER THAN WORDS<br><br>SHE LEADS HERSELF FIRST<br><br>SHE DOESN'T RAISE<br>HER VOICE, SHE<br>DOESN'T NEED TO",
        centerDescription: "HER PRESENCE SPEAKS<br>LOUDER THAN WORDS",
        bottomDescription: "SHE DOESN'T RAISE<br>HER VOICE, SHE<br>DOESN'T NEED TO",
        rightText: "SHE LEADS HERSELF FIRST",
        collectionDescription: "Curated by stylists and psychologists, matched by your test. This is Confidence. And it fits.",
        collectionButtonText: "Explore Your Confidence Set",
        traits: ["ELEGANCE", "SOPHISTICATION", "BOLDNESS"],
        wearText: "Wear it as a daily reminder of the power you carry within.",
        powerWithinText: "THE POWER WITHIN", 
        buttonTraits: ["FEARLESS", "FOCUSED", "INDEPENDENT", "AMBITIOUS", "ELEVATED"],
        sheIsTextTop: "She doesn't raise her voice. She doesn't need to. Her presence says everything.",
        sheIsTextCenter: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear.",
        sheIsTextBottom: "She leads herself first. She knows. She moves. She owns the moment.",
        collectionIntro: "THESE ARE NOT JUST JEWELLERY — THEY'RE REFLECTIONS",
        ctaDescription: "You've seen one part of your Essence. But this collection was created to be worn as a whole — where every piece amplifies the others. Together, they express your presence, power and clarity.",
        dualTexts: {
          alsoTextMiddle: "She knows. She moves. She owns the moment.",
          centerDescription: "She leads herself first.",
          bottomDescription: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear."
        },
        capsules: {
          'confidence-capsule-1': {
            title: '01 - The Defined <span>One</span>',
            description: 'Sculpted for presence, not permission.<br><br>Every piece is a quiet act of clarity and strength.'
          },
          'confidance-capsule-2': {
            title: '02 - The Dual <span>One</span>',
            description: 'Silver and gold. Soft and strong.<br><br>She wears both — unapologetically.'
          }
        },
        chartSingleDescription: "She moves through the world quietly, yet unmistakably present. Her strength isn't loud — it's the steady calm beneath the surface.<br><br>She leads with clarity, choosing her path with subtle assurance. This is not about showing off, but about knowing her own power.<br><br><br>This means she resonates with:",
        chartSingleTraits: ["Fearless", "INDEPENDANT", "focused", "ambitious"],
        descriptionTitleLine1: "Calm power with",
        descriptionTitleLine2: "inner wisdom.",
        descriptionTraits: ["Strong, statement forms", "Bold, clear shapes", "Sharp, confident lines"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/confidence_r.jpg?v=1752522516"
      },
      serenity: {
        name: "SERENITY",
        color: "#F0C8D0",
        topRightText: "SHE CARRIES A QUIET<br>KIND OF BEAUTY —<br>GENTLE, GRACEFUL",
        mainDescription: "She becomes the calm, <br>not the noise.",
        singleResult: {
          leftImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/serenity-left.jpg?v=1750025553",
          rightImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/serenity-right.jpg?v=1750025554",
          textTopLeft: "She carries a quiet kind of beauty — gentle, graceful, effortlessly calm",
          textCenterCenter: "Her silhouettes are soft. Her presence is magnetic.",
          textBottomRight: "She becomes the calm, not the noise."
        },
        sheIsTraits: "SOFT SILHOUETTES<br>FLOWING LINES<br><br>SHE EMBRACES THE BEAUTY<br>OF SIMPLICITY<br><br>HER CALM IS<br>EFFORTLESSLY<br>MAGNETIC",
        centerDescription: "WHISPER-LIGHT CHAINS<br>GENTLE GRACE",
        bottomDescription: "SHE EMBRACES THE BEAUTY<br>OF SIMPLICITY, AND<br>HER CALM IS MAGNETIC",
        rightText: "FLOWING LINES, SOFT ENERGY",
        collectionDescription: "Not a trend. A carefully crafted mirror of inner peace and emotional depth — designed by stylists and psychologists.",
        collectionButtonText: "Explore Your Serenity capsules",
        traits: ["GRACE", "TRANQUILITY", "HARMONY"],
        wearText: "Wear it as a reminder to find beauty in simplicity.",
        powerWithinText: "Soft by Nature", 
        buttonTraits: ["INNER BALANCE", "EMOTIONAL DEPTH", "DREAMY ELEGANCE", "LIGHTNESS", "SENSITIVITY"],
        sheIsTextTop: "She doesn't raise her voice. She doesn't need to. Her presence says everything.",
        sheIsTextCenter: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear.",
        sheIsTextBottom: "She leads herself first. She knows. She moves. She owns the moment.",
        collectionIntro: "THESE ARE NOT JUST JEWELLERY — THEY'RE REFLECTIONS",
        ctaDescription: "You've seen one part of your Essence. But this collection was created to be worn as a whole — where every piece amplifies the others. Together, they express your softness, strength and stillness.",
        dualTexts: {
          alsoTextMiddle: "Her silhouettes are soft.",
          centerDescription: "Her presence is magnetic.",
          bottomDescription: "She carries a quiet kind of beauty — gentle, graceful, effortlessly calm."
        },
        capsules: {
          'serenity-capsule-1': {
            title: '01 - The Light <span>Within</span>',
            description: 'Gentle light. Deep strength.<br>For those who shine from the inside out.'
          },
          'serenity-capsule-2': {
            title: '02 - The Pearltouch <span>One</span>',
            description: 'Soft to the skin, deep to the soul.<br><br>Pieces that hold, not just adorn.'
          }
        },
        chartSingleDescription: "She holds a quiet light, steady and soft. Her calm isn't absence of feeling, but a graceful presence within it.<br><br>She embraces stillness and depth without Her energy invites peace, both in herself and those around her.<br><br><br>This means she resonates with:",
        chartSingleTraits: ["Inner balance", "Emotional depth", "Lightness", "Sensitivity"],
        descriptionTitleLine1: "Gentle calm with",
        descriptionTitleLine2: "quiet strength.",
        descriptionTraits: ["Soft, flowing lines", "Light, natural tones", "Calm, gentle shapes"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/serenity_f.jpg?v=1752523231"
      },
      passion: {
        name: "PASSION",
        color: "#A72831",
        topRightText: "THERE'S FIRE IN<br>HER EYES AND<br>DEPTH IN HER SOUL",
        mainDescription: "She doesn't just wear<br> jewellery — she feels it.<br><br>Her energy is magnetic.",
        singleResult: {
          leftImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/passion-left.jpg?v=1750025553",
          rightImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/passion-right.jpg?v=1750025554",
          textTopLeft: "She doesn't just wear jewellery — she feels it.",
          textCenterCenter: "Her energy is magnetic, her presence unforgettable.",
          textBottomRight: "Gemstones that hold meaning, just like her feelings"
        },
        sheIsTraits: "SHE DOESN'T HOLD BACK<br>HER FEELINGS<br><br>HER EMOTIONS ARE<br>HER SUPERPOWER<br><br>SHE LOVES WITH<br>HER WHOLE<br>HEART",
        centerDescription: "HER EMOTIONS ARE<br>HER POWER",
        bottomDescription: "SHE LOVES WITH<br>HER WHOLE HEART AND<br>LIVES WITH FULL INTENSITY",
        rightText: "HER VULNERABILITY IS STRENGTH",
        collectionDescription: "Designed with emotional depth in mind — and curated to echo the Passion that lives within you.",
        collectionButtonText: "Explore Your passion capsules",
        traits: ["INTENSITY", "EMOTION", "STRENGTH"],
        wearText: "Wear it as a celebration of your passionate soul.",
        powerWithinText: "Effortlessly Eternal", 
        buttonTraits: ["Emotional depth", "Charisma", "Mystery", "Bold sensuality", "Magnetic presence"], 
        sheIsTextTop: "She doesn't raise her voice. She doesn't need to. Her presence says everything.",
        sheIsTextCenter: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear.",
        sheIsTextBottom: "She leads herself first. She knows. She moves. She owns the moment.",
        collectionIntro: "JEWELLERY FOR THE WOMAN WHO FEELS EVERYTHING",
        ctaDescription: "You've seen one part of your Essence. But this collection was created to be worn as a whole — where every piece amplifies the others. Together, they express your intensity, depth and authenticity.",
        dualTexts: {
          alsoTextMiddle: "her presence unforgettable.",
          centerDescription: "Gemstones that hold meaning, just like her feelings",
          bottomDescription: "and beautifully composed"
        },
        capsules: {
          'passion-capsule-1': {
            title: '01 - The Magnetic <span>One</span>',
            description: 'Quiet intensity.<br><br>Jewellery that pulls you in — like she does.'
          },
          'passion-capsule-2': {
            title: '02 - The Daring <span>One</span>',
            description: 'Unapologetic sparkle.<br><br>Presence that doesn\'t ask — it declares.'
          }
        },
        chartSingleDescription: "She lives in moments charged with emotion and meaning. Her energy is a slow burn — rich, magnetic, alive.<br><br>She carries a story in every glance, a fire in every touch. Being present is her gift; feeling deeply is her strength.<br><br><br>This means she resonates with:",
        chartSingleTraits: ["Emotional depth", "Charisma", "Mystery", "Magnetic presence"],
        descriptionTitleLine1: "Deep feeling with",
        descriptionTitleLine2: "Intense spark.",
        descriptionTraits: ["Rich, vibrant tones", "Statement gemstones", "Fluid, sensual lines"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/passion_r.jpg?v=1752522517"
      },
      timeless_elegance: {
        name: "TIMELESS GRACE",
        color: "#376575",
        topRightText: "SHE DOESN'T CHASE<br>ATTENTION — SHE SIMPLY<br>EMBODIES ELEGANCE",
        mainDescription: "She doesn't chase attention — <br>she simply embodies elegance.<br><br>Gold, silver, pearls — <br>quiet luxuries that never fade",
        singleResult: {
          leftImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/timeless-left.jpg?v=1750025553",
          rightImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/timeless-right.jpg?v=1750025553",
          textTopLeft: "She doesn't chase attention — she simply embodies elegance.",
          textCenterCenter: "Gold, silver, pearls — quiet luxuries that never fade",
          textBottomRight: "Her style is quiet, refined, and beautifully composed."
        },
        sheIsTraits: "GOLD, SILVER, PEARLS<br>QUIET LUXURIES<br><br>HER STYLE IS QUIET<br>REFINED, AND BEAUTIFULLY<br>COMPOSED<br><br>ELEGANCE THAT<br>NEVER FADES",
        centerDescription: "QUIET LUXURIES<br>THAT NEVER FADE",
        bottomDescription: "HER STYLE IS QUIET,<br>REFINED, AND<br>BEAUTIFULLY COMPOSED",
        rightText: "TIMELESS GRACE AND ELEGANCE",
        collectionDescription: "This isn't about fashion — it's about timeless presence, quiet confidence, and unmistakable grace.",
        collectionButtonText: "view all timeless grace",
        traits: ["REFINEMENT", "SOPHISTICATION", "GRACE"],
        wearText: "Wear it as a testament to your enduring style.",
        powerWithinText: "THE POWER WITHIN",
        buttonTraits: ["Quiet Authority", "Refined", "Iconic", "Elegant Precision", "Polished"],
        sheIsTextTop: "She doesn't raise her voice. She doesn't need to. Her presence says everything.",
        sheIsTextCenter: "She walks into the room — and the energy shifts. Not because she tries. But because she's clear.",
        sheIsTextBottom: "She leads herself first. She knows. She moves. She owns the moment.",
        collectionIntro: "THESE ARE NOT JUST JEWELLERY — THEY'RE REFLECTIONS",
        ctaDescription: "You've seen one part of your Essence. But this collection was created to be worn as a whole — where every piece amplifies the others. Together, they express your grace, refinement and timeless beauty.",
        dualTexts: {
          alsoTextMiddle: "Her presence speaks louder than words",
          centerDescription: "Her style is quiet, refined",
          bottomDescription: "and beautifully composed"
        },
        capsules: {
          'the-eternal-one': {
            title: '01 - The Eternal <span>One</span>',
            description: 'She doesn\'t seek attention — she carries legacy.<br><br>Crafted in timeless tennis style, this capsule reflects grace that outlives trends.'
          },
          'the-pure-one': {
            title: '02 - The Pure <span>One</span>',
            description: 'Natural pearls. Quiet legacy.<br><br>Made to be treasured — and passed on.'
          }
        },
        chartSingleDescription: "She embodies elegance that speaks softly but lasts forever. Her beauty is in restraint — a quiet confidence that never fades.<br><br>Each detail chosen with care, each piece a part of her story. Timeless Grace isn't a trend — it's a way of being.<br><br><br>This means she resonates with:",
        chartSingleTraits: ["Quiet Authority", "Refined", "Iconic", "Elegant Precision"],
        descriptionTitleLine1: "Quiet power with",
        descriptionTitleLine2: "endless elegance.",
        descriptionTraits: ["Classic, refined silhouettes", "Elegant pearl accents", "Subtle, enduring shine"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/timeless_f.jpg?v=1752523231"
      }
    };

    this.dualCombinations = {
      'confidence_passion': {
        description: "She doesn't choose between strength and feeling — she is both. Her confidence burns with intensity.<br><br>She's magnetic not because she tries, but because she dares to be completely herself — powerful and passionate, decisive and deep.<br><br><br>This means she resonates with:",
        traits: ["Fearless", "INDEPENDANT", "Emotional depth", "Charisma"],
        descriptionTitleLine1: "Bold elegance with",
        descriptionTitleLine2: "a magnetic edge.",
        descriptionTraits: ["Strong, statement forms", "Harmonious, graceful curves", "Deep, vibrant hues"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/confidence_passion_r.jpg?v=1752522516"
      },
      
      'confidence_timeless_elegance': {
        description: "She carries quiet strength paired with natural elegance. Her presence blends clarity with calm, decisiveness with timeless refinement.<br><br>She moves through life with assuredness and depth, always true to herself.<br><br><br>This means she resonates with:",
        traits: ["Fearless", "INDEPENDANT", "Quiet Authority", "Iconic"],
        descriptionTitleLine1: "Unshakable strength",
        descriptionTitleLine2: "with timeless poise.",
        descriptionTraits: ["Strong, statement forms", "Timeless, polished style", "Balanced, confident shine"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/confidence_timeless_r.jpg?v=1752522516"
      },
      
      'serenity_timeless_elegance': {
        description: "She radiates calm and gentle nobility. Her energy is softness and poise intertwined with purity and grace.<br><br>She holds a space of quiet depth, where authenticity and beauty quietly dwell.<br><br><br>This means she resonates with:",
        traits: ["Inner balance", "Sensitivity", "Quiet Authority", "Iconic"],
        descriptionTitleLine1: "Calm sophistication",
        descriptionTitleLine2: "with quiet power.",
        descriptionTraits: ["Soft, elegant shapes", "Calm, classic tones", "Balanced, graceful forms"],
        descriptionImage: "https://cdn.shopify.com/s/files/1/0702/8126/5374/files/serenity_timeless_r.jpg?v=1752522517"
      }
    };
  
    this.currentQuizStep = 1;
    this.quizStarted = false;

    this.analytics = new QuizAnalytics();
    this.productInteractions = {};
    this.scrollDepthTracked = false;
    
  }

  createStructuredText(textTopLeft, textCenterCenter, textBottomRight) {
    return `
      <div class="essence-text-top-left">${textTopLeft}</div>
      <div class="essence-text-center-center">${textCenterCenter}</div>
      <div class="essence-text-bottom-right">${textBottomRight}</div>
    `;
  }

  async init() {
    if (!this.quizElement) return;

    this.analytics.initializeTracking();
    
    this.progressText = this.quizElement.querySelector('.quiz-progress-text');
    this.createProgressSegments();
    
    this.setupEventListeners();
    this.setupProgressNavigation();
    this.addSelectionHandlers();
    this.goToStep(1);
    this.updateProgress();
    this.setupCollectionButtonHandlers();
  }

  createProgressSegments() {
    const progressBar = this.quizElement.querySelector('.quiz-progress-bar');
    
    progressBar.innerHTML = '';
    progressBar.className = 'quiz-progress-segments';
    
    for (let i = 1; i <= this.totalSteps; i++) {
      const segment = document.createElement('div');
      segment.className = 'progress-segment';
      segment.dataset.step = i;
      segment.innerHTML = '&nbsp;';
      progressBar.appendChild(segment);
    }
    
    this.progressSegments = progressBar.querySelectorAll('.progress-segment');
  }

  setupProgressNavigation() {
    this.progressSegments.forEach(segment => {
      segment.addEventListener('click', (e) => {
        const targetStep = parseInt(e.target.dataset.step);
        const isCompleted = this.currentStep > this.totalSteps;
        
        if (!isCompleted && targetStep <= this.currentStep) {
          this.goToStep(targetStep + 1);
        }
      });
    });
  }
  
  createCollectionHeader(container, essenceKey, essenceData, isSingle = false) {
    const collectionSection = document.createElement('div');
    collectionSection.className = isSingle ? 'collection-slider-section single-essence-section' : 'collection-slider-section';
    if (isSingle) {
      collectionSection.setAttribute('data-essence', essenceKey);
      collectionSection.setAttribute('data-single-result', 'true');
    }
    
    const textColor = essenceKey === 'serenity' ? '#222222' : '#FFFFFF';
    
    collectionSection.innerHTML = `
      <div id="product-collection" class="collection-header ${isSingle ? 'single-essence-header' : ''}" ${isSingle ? `data-essence="${essenceKey}"` : ''}>
        <div class="collection-intro">${essenceData.collectionIntro}</div>
        <div class="collection-title" style="color: ${essenceData.color}">${essenceData.name}</div>
        <div class="collection-subtitle">COLLECTION</div>
        <div class="collection-description">${essenceData.collectionDescription}</div>
        <button class="collection-button" style="background: ${essenceData.color}; border-color: ${essenceData.color}; color: ${textColor};">
          ${essenceData.collectionButtonText || `VIEW ALL ${essenceData.name}`}
        </button>
      </div>
    `;
    container.appendChild(collectionSection);
  }
  
  displaySingleResult(essence, percent) {
    const resultsContainer = document.querySelector('.quiz-step[data-step="11"]');
    resultsContainer.classList.remove('dual-essence-result', 'single-essence-result');
    resultsContainer.removeAttribute('data-primary-essence');
    resultsContainer.removeAttribute('data-secondary-essence');
    resultsContainer.removeAttribute('data-single-essence');
    
    resultsContainer.classList.remove('hidden');
    resultsContainer.classList.add('single-essence-result');
    resultsContainer.setAttribute('data-single-essence', essence);
    
    const essenceData = this.essenceDescriptions[essence];
  
    this.updateElement('.essence-code-top-right', essenceData.topRightText);
    
    this.updateElement('.main-essence-title', `${percent}% ${essenceData.name}`);
    this.setElementColor('.main-essence-title', essenceData.color);

    const mainTitle = document.querySelector('.main-essence-title');
    if (mainTitle) {
      mainTitle.innerHTML = `${percent}% ${essenceData.name}`;
      mainTitle.style.color = essenceData.color;
      mainTitle.style.borderBottomColor = essenceData.color;
    
      if (essenceData.name === 'TIMELESS GRACE' && percent === 100) {
        mainTitle.style.fontSize = '130px';
        mainTitle.style.lineHeight = '1.1';
      } else {
        mainTitle.style.fontSize = ''; 
      }
    }

    
    this.updateElement('.single-essence-left', `${percent}% ${essenceData.name}`);
    this.setElementColor('.single-essence-left', essenceData.color);
    
    this.updateElement('.single-essence-right', essenceData.powerWithinText);
  
    const titleElement = document.querySelector('.main-essence-title');
    if (titleElement) {
      titleElement.style.borderBottomColor = essenceData.color;
    }
    
    const buttonTraitsContainer = document.querySelector('.single-essence-buttons');
    if (buttonTraitsContainer) {
      buttonTraitsContainer.innerHTML = essenceData.buttonTraits.map(trait => 
        `<button class="essence-trait-button" style="border-color: ${essenceData.color}; color: ${essenceData.color};">
          ${trait}
        </button>`
      ).join('');
    }
  
    const elementsToHide = document.querySelectorAll('.left-column .essence-name, .left-column .percentage, .left-column .description, .right-column');
    elementsToHide.forEach(el => {
      if (el) el.style.display = 'none';
    });
  
    const elementsToShow = document.querySelectorAll('.main-essence-title, .single-essence-left, .single-essence-right, .single-essence-buttons');
    elementsToShow.forEach(el => {
      if (el) el.style.display = 'block';
    });
    
    const detailedDescriptions = document.querySelector('.detailed-descriptions');
    if (detailedDescriptions) {
      detailedDescriptions.style.display = 'block';
    }
  
    this.updatePrimaryColorCSS(essenceData.color, essenceData.color);  
    this.updateSingleDetailedSections(essenceData);

    this.createResultChart(essence, null, percent, 0);
    this.updateChartInfoSection(essence, null, percent, 0);

    this.updateEssenceDescriptionSection(essence, null, percent, 0);

    setTimeout(() => {
      setupProductViewTracking();
    }, 1000);
    
  }

  updateSingleDetailedSections(essenceData) {
    this.updateElement('.primary-name', `${essenceData.name}.`);
    this.setElementColor('.primary-name', essenceData.color);
    this.updateElement('.collection-label', `${essenceData.name} COLLECTION`);
     
    const collectionLabel = document.querySelector('.collection-label:not(.right-collection-label)');
    if (collectionLabel) {
      if (window.innerWidth < 768) {
        collectionLabel.style.backgroundColor = ''; 
        collectionLabel.style.color = essenceData.color;
      } else {
        collectionLabel.style.backgroundColor = essenceData.color;
        collectionLabel.style.color = '#fff';
      }
    }
    
    const primaryCollectionButton = document.querySelector('.primary-collection-button');
    if (primaryCollectionButton) {
      primaryCollectionButton.innerHTML = `${essenceData.name} COLLECTION'S`;
      primaryCollectionButton.style.display = 'block';
      primaryCollectionButton.style.setProperty('background', essenceData.color, 'important');
    }
    
    const secondaryElements = document.querySelectorAll('.secondary-center, .but-she-is, .also-text, .secondary-name, .center-description, .secondary-collection-label, .bottom-description');
    secondaryElements.forEach(el => {
      if (el) el.style.display = 'none';
    });
    
    this.updateSingleResultContent(essenceData);
    
    this.updateElement('.collection-title', essenceData.name);
    const collectionButton = document.querySelector('.collection-button');
    if (collectionButton) {
      collectionButton.innerHTML = `${essenceData.name} COLLECTION'S`;
    }
  }

  updateSingleResultContent(essenceData) {
    const singleData = essenceData.singleResult;
    
    const primaryImageEl = document.querySelector('.primary-image img');
    if (primaryImageEl) {
      primaryImageEl.src = singleData.leftImage;
    }
    
    const rightImageEl = document.querySelector('.she-is-right-image img');
    if (rightImageEl) {
      rightImageEl.src = singleData.rightImage;
    }
    
    const structuredText = this.createStructuredText(
      singleData.textTopLeft,
      singleData.textCenterCenter,
      singleData.textBottomRight
    );
    
    const descriptionElement = document.querySelector('.primary-left-col-description');
    if (descriptionElement) {
      descriptionElement.innerHTML = structuredText;
    }
    
    const primaryLeftCol1 = document.querySelector('.primary-left-col-1');
    const primaryLeftCol2 = document.querySelector('.primary-left-col-2');
    
    if (primaryLeftCol1 && primaryLeftCol2) {
      const primaryImageContainer = primaryLeftCol1.querySelector('.primary-image');
      const rightImageContainer = primaryLeftCol1.querySelector('.she-is-right-image');
      
      if (primaryImageContainer && rightImageContainer) {
        primaryLeftCol1.innerHTML = '';
        
        primaryLeftCol1.appendChild(primaryImageContainer);
        primaryLeftCol1.appendChild(primaryLeftCol2);
        primaryLeftCol1.appendChild(rightImageContainer);
        
        rightImageContainer.style.display = 'block';
        rightImageContainer.style.visibility = 'visible';
      }
    }
  }
  
  displayDualResults(primary, secondary, primaryPercent, secondaryPercent) {
    document.querySelector('.quiz-step[data-step="11"]').classList.remove('hidden');
    
    const primaryData = this.essenceDescriptions[primary];
    const secondaryData = this.essenceDescriptions[secondary];
  
    const resultsContainer = document.querySelector('.quiz-step[data-step="11"]');
    resultsContainer.classList.add('dual-essence-result');
    resultsContainer.setAttribute('data-primary-essence', primary);
    resultsContainer.setAttribute('data-secondary-essence', secondary);
  
    this.updateElement('.essence-code-top-right', primaryData.topRightText);
    this.updateElement('.left-column .essence-name', `${primaryPercent}% ${primaryData.name.toUpperCase()}`);
    this.updateElement('.left-column .percentage', `${primaryData.name.toUpperCase()}`);
    this.updateElement('.left-column .description', primaryData.mainDescription);
    this.updateElement('.right-column .top-description', secondaryData.topRightText);
    this.updateElement('.right-column .essence-name', `${secondaryPercent}% ${secondaryData.name.toUpperCase()}`);
    this.updateElement('.right-column .percentage', `${secondaryData.name.toUpperCase()}`);
  
    this.setElementColor('.left-column .essence-name', primaryData.color);
    this.setElementColor('.right-column .essence-name', secondaryData.color);
    
    const leftEssenceName = document.querySelector('.left-column .essence-name');
    const rightEssenceName = document.querySelector('.right-column .essence-name');
    
    if (leftEssenceName && leftEssenceName.textContent.includes('TIMELESS GRACE')) {
      leftEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      leftEssenceName.style.lineHeight = '1.1';
    }
    
    if (rightEssenceName && rightEssenceName.textContent.includes('TIMELESS GRACE')) {
      rightEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      rightEssenceName.style.lineHeight = '1.1';
    }
    
    this.updatePrimaryColorCSS(primaryData.color, secondaryData.color);
  
    const elementsToHide = document.querySelectorAll('.main-essence-title, .single-essence-container, .single-essence-buttons');
    elementsToHide.forEach(el => {
      if (el) el.style.display = 'none';
    });
  
    const elementsToShow = document.querySelectorAll('.dual-columns, .detailed-descriptions');
    elementsToShow.forEach(el => {
      if (el) el.style.display = 'block';
    });

    const imagesToShow = document.querySelectorAll('.primary-image, .primary-image-right');
    imagesToShow.forEach(img => {
      if (img) {
        img.style.display = 'block';
        img.style.visibility = 'visible';
      }
    });
    
    this.updateDetailedSections(primaryData, secondaryData);
    this.reorderMobileElements();

    this.createResultChart(primary, secondary, primaryPercent, secondaryPercent);
    this.updateChartInfoSection(primary, secondary, primaryPercent, secondaryPercent);

    this.updateEssenceDescriptionSection(primary, secondary, primaryPercent, secondaryPercent);

    setTimeout(() => {
      setupProductViewTracking();
    }, 1000);
    
  }
  
  reorderMobileElements() {
    if (window.innerWidth <= 768) {
      const primaryLeft = document.querySelector('.primary-left');
      if (primaryLeft) {
        this.reorderLeftSide(primaryLeft);
      }
      
      const primaryRight = document.querySelector('.primary-right');
      if (primaryRight) {
        this.reorderRightSide(primaryRight);
      }
    }
  }
  
  reorderLeftSide(primaryLeft) {
    const mobileContainer = document.createElement('div');
    mobileContainer.className = 'mobile-reordered-container-left';
    
    const sheIsBlock = primaryLeft.querySelector('.she-is-block');
    if (sheIsBlock) {
      mobileContainer.appendChild(sheIsBlock.cloneNode(true));
    }
    
    const collectionLabel = primaryLeft.querySelector('.collection-label');
    if (collectionLabel) {
      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'mobile-button-container-left';
      buttonContainer.appendChild(collectionLabel.cloneNode(true));
      mobileContainer.appendChild(buttonContainer);
    }
    
    const primaryImage = primaryLeft.querySelector('.primary-image');
    if (primaryImage) {
      mobileContainer.appendChild(primaryImage.cloneNode(true));
    }
    
    const description = primaryLeft.querySelector('.primary-left-col-description');
    if (description) {
      mobileContainer.appendChild(description.cloneNode(true));
    }
    
    const textsColumn = primaryLeft.querySelector('.she-is-texts-column');
    if (textsColumn) {
      mobileContainer.appendChild(textsColumn.cloneNode(true));
    }
    
    const rightImage = primaryLeft.querySelector('.she-is-right-image');
    if (rightImage) {
      mobileContainer.appendChild(rightImage.cloneNode(true));
    }
    
    primaryLeft.innerHTML = '';
    primaryLeft.appendChild(mobileContainer);
  }
  
  reorderRightSide(primaryRight) {
    const mobileContainer = document.createElement('div');
    mobileContainer.className = 'mobile-reordered-container';
    
    const secondaryCenter = primaryRight.querySelector('.secondary-center');
    if (secondaryCenter) {
      const textContainer = document.createElement('div');
      textContainer.className = 'secondary-center-text';
      
      const butSheIs = secondaryCenter.querySelector('.but-she-is');
      const alsoText = secondaryCenter.querySelector('.also-text');
      const secondaryName = secondaryCenter.querySelector('.secondary-name');
      
      if (butSheIs) textContainer.appendChild(butSheIs.cloneNode(true));
      if (alsoText) {
        const alsoTextClone = alsoText.cloneNode(false);
        alsoTextClone.textContent = alsoText.textContent.replace(alsoText.querySelector('.also-text-middle')?.textContent || '', '').trim();
        textContainer.appendChild(alsoTextClone);
      }
      if (secondaryName) textContainer.appendChild(secondaryName.cloneNode(true));
      
      mobileContainer.appendChild(textContainer);
    }
    
    const collectionLabel = secondaryCenter?.querySelector('.collection-label');
    if (collectionLabel) {
      const buttonContainer = document.createElement('div');
      buttonContainer.className = 'mobile-button-container';
      buttonContainer.appendChild(collectionLabel.cloneNode(true));
      mobileContainer.appendChild(buttonContainer);
    }
    
    const primaryImageRight = primaryRight.querySelector('.primary-image-right');
    if (primaryImageRight) {
      mobileContainer.appendChild(primaryImageRight.cloneNode(true));
    }
    
    const centerDescription = secondaryCenter?.querySelector('.center-description');
    if (centerDescription) {
      mobileContainer.appendChild(centerDescription.cloneNode(true));
    }
    
    const bottomDescription = secondaryCenter?.querySelector('.bottom-description');
    if (bottomDescription) {
      mobileContainer.appendChild(bottomDescription.cloneNode(true));
    }
    
    primaryRight.innerHTML = '';
    primaryRight.appendChild(mobileContainer);
  }
  
  loadSingleEssenceProducts(essence) {
    const container = document.getElementById('essence-products-container');
    container.innerHTML = '';

    const collectionMap = {
      confidence: ['confidence-capsule-1', 'confidance-capsule-2'],
      serenity: ['serenity-capsule-1', 'serenity-capsule-2'],
      passion: ['passion-capsule-1', 'passion-capsule-2'], 
      timeless_elegance: ['the-eternal-one', 'the-pure-one']
    };
    
    const essenceData = this.essenceDescriptions[essence];

    this.createCollectionHeader(container, essence, essenceData, true);

    const sectionId = `${essence}-collection-section`;
    const currentSection = container.querySelector('.collection-slider-section:last-child');
    if (currentSection) {
        currentSection.id = sectionId;
    }

    collectionMap[essence].forEach((capsuleId, index) => {
      const capsuleElement = document.getElementById(capsuleId);
      
      if (!capsuleElement) {
        return;
      }
      
      const products = JSON.parse(capsuleElement.textContent).products;
      if (products.length === 0) return;

      const capsuleNumber = index + 1;
      const capsuleInfo = essenceData.capsules[capsuleId];
      
      if (!capsuleInfo) {
        console.error('Capsule info not found for:', capsuleId);
        return;
      }
      
      this.createSingleCapsuleSlider(container, essence, essenceData, capsuleId, capsuleNumber, products, capsuleInfo);
    });

    this.hideFinalSection();
  }
  
  hideFinalSection() {
    const finalSections = document.querySelectorAll('.collection-title, .primary-collection-button, .final-collection-section');
    finalSections.forEach(section => {
      if (section && !section.closest('.collection-header')) {
        section.style.display = 'none';
      }
    });
  }

  setupEventListeners() {

    this.quizElement.querySelectorAll('.quiz-next').forEach(button => {
      button.addEventListener('click', (e) => this.handleNext(e));
    });

    this.quizElement.querySelectorAll('.quiz-skip').forEach(button => {
      button.addEventListener('click', (e) => this.handleSkip(e));
    });
  }

  showNameError(stepDiv, message) {
    const nameInput = stepDiv.querySelector('#quiz-name');
    const errorDiv = stepDiv.querySelector('#quiz-name-error');
    
    nameInput.style.borderColor = '#ff4444';
    errorDiv.textContent = message;
    errorDiv.classList.add('visible');
  }
  
  hideNameError(stepDiv) {
    const nameInput = stepDiv.querySelector('#quiz-name');
    const errorDiv = stepDiv.querySelector('#quiz-name-error');
    
    nameInput.style.borderColor = '';
    errorDiv.textContent = '';
    errorDiv.classList.remove('visible');
  }

  handleNext(e) {
    const stepNum = parseInt(e.target.closest('.quiz-step').dataset.step);
    const currentStepDiv = e.target.closest('.quiz-step');
    
    if (stepNum >= 2 && stepNum <= 9) {
      const selected = currentStepDiv.querySelector('input[type="radio"]:checked');
      
      if (!selected) {
        this.showValidationError(currentStepDiv);
        return;
      }
      
      this.hideValidationError(currentStepDiv);
      
      if (selected && selected.value) {
        this.scores[selected.value]++;
      }
    }
    
   if (stepNum === 10) {
      const nameInput = currentStepDiv.querySelector('#quiz-name');
      const emailInput = currentStepDiv.querySelector('#quiz-email');
      const name = nameInput.value.trim();
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      if (!name) {
        this.showNameError(currentStepDiv, 'Name is required.');
        return;
      }
      
      if (!email) {
        this.showEmailError(currentStepDiv, 'Email is required.');
        return;
      } else if (!emailRegex.test(email)) {
        this.showEmailError(currentStepDiv, 'Please enter a valid email address.');
        return;
      }
      
      this.hideNameError(currentStepDiv);
      this.hideEmailError(currentStepDiv);
      
      let firstName = name;
      let lastName = '';
      const nameParts = name.split(' ');
      if (nameParts.length > 1) {
        firstName = nameParts[0];
        lastName = nameParts.slice(1).join(' ');
      }
      
      window.quizUserData = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        fullName: name
      };
      
      if (window.essenceQuiz && window.essenceQuiz.analytics) {
        window.essenceQuiz.analytics.trackUserInfo(window.quizUserData);
      }
    }
    
    this.goToStep(stepNum + 1);
    
    if (this.analytics) {
      if (stepNum >= 2 && stepNum <= 9) {
        const selected = currentStepDiv.querySelector('input[type="radio"]:checked');
        this.analytics.trackStepChange(stepNum, stepNum + 1, selected?.value);
      } else {
        this.analytics.trackStepChange(stepNum, stepNum + 1);
      }
    }
    
    this.currentQuizStep = stepNum;
    this.sendStepToKlaviyo(stepNum, 'completed_step');
    
    if (stepNum === 9) {
    } else if (stepNum === 10) {
      this.calculateResults();
    }
  }

  showValidationError(stepDiv) {
    let errorDiv = stepDiv.querySelector('.quiz-validation-error');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'quiz-validation-error';
      errorDiv.textContent = 'Please select an answer to continue';
      errorDiv.style.cssText = `
        color: #ff4444;
        font-size: 14px;
        margin: 10px 0;
        text-align: center;
      `;
      
      const buttonContainer = stepDiv.querySelector('.question-buttons');
      if (buttonContainer) {
        buttonContainer.parentNode.insertBefore(errorDiv, buttonContainer);
      } else {
        const nextButton = stepDiv.querySelector('.quiz-next');
        nextButton.parentNode.insertBefore(errorDiv, nextButton);
      }
    }
    errorDiv.style.display = 'block';
  }

  showEmailError(stepDiv, message) {
    const emailInput = stepDiv.querySelector('#quiz-email');
    const errorDiv = stepDiv.querySelector('#quiz-email-error');
    
    emailInput.style.borderColor = '#ff4444';
    errorDiv.textContent = message;
    errorDiv.classList.add('visible');
  }
  
  hideEmailError(stepDiv) {
    const emailInput = stepDiv.querySelector('#quiz-email');
    const errorDiv = stepDiv.querySelector('#quiz-email-error');
    
    emailInput.style.borderColor = '';
    errorDiv.textContent = '';
    errorDiv.classList.remove('visible');
  }
  
  hideValidationError(stepDiv) {
    const errorDiv = stepDiv.querySelector('.quiz-validation-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  }
    
  handleSkip(e) {
    const stepNum = parseInt(e.target.closest('.quiz-step').dataset.step);

    this.analytics.trackSkip(stepNum);
    
    if (stepNum < 10) {
      this.goToStep(stepNum + 1);
    }
    
    if (stepNum === 9) {
      this.calculateResults();
    }
  }

  goToStep(step) {

    const currentStep = this.currentStep;
    
    this.quizElement.querySelectorAll('.quiz-step').forEach(div => div.classList.add('hidden'));
    const currentStepDiv = this.quizElement.querySelector(`.quiz-step[data-step="${step}"]`);
    
    if (currentStepDiv) {
      currentStepDiv.classList.remove('hidden');

      if (step < currentStep) {
        this.analytics.trackBackNavigation(currentStep, step);
      }
      
      this.currentStep = step;
      this.updateProgress();

      if (step === 11) {
        setTimeout(() => {
          startScrollDepthTracking();
        }, 1000);
      }
      
    }
  }

  updateProgress() {
    if (this.currentStep > 1 && this.currentStep <= this.totalSteps) {
      
      let displayStep;
      if (this.currentStep <= 9) {
        displayStep = this.currentStep - 1;
      } else if (this.currentStep === 10) {
        displayStep = 9;
      }
      
      this.progressText.textContent = `STEP ${displayStep} OF 9`;
      
      if (this.progressSegments) {
        this.progressSegments.forEach((segment, index) => {
          const stepNumber = index + 1;
          segment.classList.remove('completed', 'current', 'disabled');
          
          if (this.currentStep === 10) {
            segment.classList.add('completed');
          } else {
            if (stepNumber < this.currentStep) {
              segment.classList.add('completed');
            } else if (stepNumber === this.currentStep - 1) {
              segment.classList.add('current');
            } else {
              segment.classList.add('disabled');
            }
          }
        });
      }
      
    } else if (this.currentStep > this.totalSteps) {
      this.progressText.textContent = 'COMPLETED';
      
      if (this.progressSegments) {
        this.progressSegments.forEach(segment => {
          segment.classList.remove('current', 'disabled');
          segment.classList.add('completed', 'disabled');
        });
      }
    }
  }

  addSelectionHandlers() {
    this.quizElement.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', function() {
        const textOption = this.closest('.text-option');
        if (textOption) {
          const allTextOptions = this.closest('.text-options').querySelectorAll('.text-option');
          allTextOptions.forEach(option => option.classList.remove('selected'));
          textOption.classList.add('selected');
        }
        
        const imageOption = this.closest('.image-option');
        if (imageOption) {
          const questionOptions = this.closest('.quiz-image-answers').querySelectorAll('.image-option');
          questionOptions.forEach(option => option.classList.remove('selected'));
          imageOption.classList.add('selected');
        }
        
        const gridImageOption = this.closest('.grid-image-option');
        if (gridImageOption) {
          const questionOptions = this.closest('.images-grid').querySelectorAll('.grid-image-option');
          questionOptions.forEach(option => option.classList.remove('selected'));
          gridImageOption.classList.add('selected');
        }

        const stepDiv = this.closest('.quiz-step');
        if (window.essenceQuiz) {
          window.essenceQuiz.hideValidationError(stepDiv);
        }
      });
    });
  }
  
  calculateResults() {
    const sorted = Object.entries(this.scores).sort((a, b) => b[1] - a[1]);
    const primary = sorted[0];
    const secondary = sorted[1];
    
    const totalAnswers = Object.values(this.scores).reduce((sum, score) => sum + score, 0);

    const realPercentages = this.getRealPercentages();
    
    const primaryPercent = Math.round((primary[1] / totalAnswers) * 100);
    const secondaryPercent = Math.round((secondary[1] / totalAnswers) * 100);
    
    const isDominant = primaryPercent >= 80;
    
    const allowedDualCombinations = [
      ['confidence', 'passion'],
      ['serenity', 'timeless_elegance'],
      ['confidence', 'timeless_elegance']
    ];
    
    const currentCombination = [primary[0], secondary[0]];
    const isAllowedDual = allowedDualCombinations.some(combo => 
      (combo[0] === currentCombination[0] && combo[1] === currentCombination[1]) ||
      (combo[1] === currentCombination[0] && combo[0] === currentCombination[1])
    );

    let displayPrimaryPercent, displaySecondaryPercent;
    
    if (isDominant || !isAllowedDual) {
      displayPrimaryPercent = primaryPercent < 55 ? 55 : primaryPercent;
      displaySecondaryPercent = 0;
    } else {
      const totalPercent = primaryPercent + secondaryPercent;
      if (totalPercent > 0) {
        displayPrimaryPercent = Math.round((primaryPercent / totalPercent) * 100);
        displaySecondaryPercent = 100 - displayPrimaryPercent;
      } else {
        displayPrimaryPercent = 50;
        displaySecondaryPercent = 50;
      }
    }
    
    const quiz_result = displaySecondaryPercent > 0 
      ? `${displayPrimaryPercent}% ${this.formatEssenceName(primary[0])}, ${displaySecondaryPercent}% ${this.formatEssenceName(secondary[0])}`
      : `${displayPrimaryPercent}% ${this.formatEssenceName(primary[0])}`;
      
    const quiz_result_primary = `${displayPrimaryPercent}% ${this.formatEssenceName(primary[0])}`;
    const quiz_result_secondary = displaySecondaryPercent > 0 ? `${displaySecondaryPercent}% ${this.formatEssenceName(secondary[0])}` : '';

    let essence_combination = '';
    if (isDominant || !isAllowedDual) {
      essence_combination = primary[0];
    } else {
      const sortedCombination = [primary[0], secondary[0]].sort();
      essence_combination = `${sortedCombination[0]}_${sortedCombination[1]}`;
    }

    const results = {
      quiz_result,
      quiz_result_primary,
      quiz_result_secondary,
      essence_combination,
      real_confidence_percentage: realPercentages.confidence,
      real_passion_percentage: realPercentages.passion,
      real_timeless_percentage: realPercentages.timeless_elegance,
      real_serenity_percentage: realPercentages.serenity
    };
    
    this.analytics.trackCompletion(results);

    
    if (isDominant || !isAllowedDual) {
      let shownPercent = primaryPercent < 55 ? 55 : primaryPercent;
      this.displaySingleResult(primary[0], shownPercent);
      this.loadSingleEssenceProducts(primary[0]);
      this.styleCTASection(primary[0]);
    } else {
      this.displayDualResults(primary[0], secondary[0], primaryPercent, secondaryPercent);
      this.loadProducts(primary[0], secondary[0]);
      this.styleCTASection(primary[0]);
    }
  
    this.sendStepToKlaviyo(9, 'completed', {
        quiz_result,             
        quiz_result_primary, 
        quiz_result_secondary,
        essence_combination,
        real_confidence_percentage: realPercentages.confidence,
        real_passion_percentage: realPercentages.passion,
        real_timeless_percentage: realPercentages.timeless_elegance,
        real_serenity_percentage: realPercentages.serenity
      
    });
    
    document.body.classList.add('quiz-completed');

    this.hideProgressBar();
    this.requestAndRenderTryPass();


  if (!window._tpClickBound) {
    window._tpClickBound = true;

    document.addEventListener('click', (e) => {
      const hit = e.target.closest('.try-pass__cta, .try-pass__card, .try-pass__code, .capsule-pass__cta, .capsule-pass__code');
      if (!hit) return;

      e.preventDefault();
      e.stopPropagation();

      const code =
        hit.getAttribute('data-try-pass-code') ||
        document.querySelector('.try-pass__code')?.textContent?.trim() ||
        document.getElementById('capsule-pass-code')?.textContent?.trim() ||
        '';

      if (!code) {
        console.warn('[TRY PASS] no code ready yet');
        return;
      }

      navigator.clipboard.writeText(code).catch(() => {});

      const help = document.querySelector('.capsule-pass__help, .try-pass__help');
      if (help) {
        const prev = help.textContent;
        help.textContent = 'Copied ✓';
        setTimeout(() => { help.textContent = prev; }, 1200);
      }

      if (window.applyDiscountCodeFromTryPass) {
        window.applyDiscountCodeFromTryPass(code, { open: false, noRedirect: true });
      }
    });
  }


    this.updateTryPassColors(primary[0]);

    //this.applyDiscountDisplayToCards();
    this.applyDiscountDisplayToQuickView();
    this._ensureQuickViewObserver();
  }

  /****** APPLY 40% discount at
  applyDiscountDisplayToCards(discountPercent = 40) {
    const multiplier = (100 - discountPercent) / 100;

    document.querySelectorAll('.spf-product-card__price-wrapper').forEach(wrapper => {
      if (wrapper.dataset.discountApplied === '1') return;

      if (wrapper.querySelector('.spf-product-card__oldprice')) {
        wrapper.dataset.discountApplied = '1';
        return;
      }

      const priceEl = wrapper.querySelector('.spf-product-card__price.money, .money');
      if (!priceEl) return;

      const raw = priceEl.textContent.trim();
      const m = raw.match(/([£$€])\s*([\d.,]+)/);
      if (!m) return;

      const sym = m[1];
      const num = parseFloat(m[2].replace(/,/g, ''));
      if (isNaN(num)) return;

      const sale = (num * multiplier).toFixed(2);

      wrapper.innerHTML = `
        <span class="spf-product-card__oldprice money">${sym}${num.toFixed(2)}</span>
        <span class="spf-product-card__saleprice money">${sym}${sale}</span>
      `;
      wrapper.dataset.discountApplied = '1';
    });
  }

  applyDiscountDisplayToQuickView(discountPercent = 40) {
    const priceEl = document.querySelector('.quick-view-price');
    if (!priceEl || priceEl.dataset.discountApplied === '1') return;

    const raw = priceEl.textContent.trim();
    const m = raw.match(/([£$€])\s*([\d.,]+)/);
    if (!m) return;

    const sym = m[1];
    const num = parseFloat(m[2].replace(/,/g, ''));
    if (isNaN(num)) return;

    const multiplier = (100 - discountPercent) / 100;
    const sale = (num * multiplier).toFixed(2);

    priceEl.innerHTML = `
      <span class="spf-product-card__oldprice money">${sym}${num.toFixed(2)}</span>
      <span class="spf-product-card__saleprice money">${sym}${sale}</span>
    `;
    priceEl.dataset.discountApplied = '1';
  }

  _ensureQuickViewObserver(discountPercent = 40) {
    if (this._qvObs) return;
    let t = null;
    this._qvObs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => this.applyDiscountDisplayToQuickView(discountPercent), 60);
    });
    this._qvObs.observe(document.body, { childList: true, subtree: true });
  }

  *******/


  waitForTryPassCode(maxMs = 15000) {
    const t0 = Date.now();
    return new Promise(resolve => {
      const tick = () => {
        const code =
          (this.tryPass && this.tryPass.code) ||
          window.__tryPassCode || null;
        const endsAt =
          (this.tryPass && this.tryPass.endsAt) ||
          (typeof this.getTryPassEndsAt === 'function' ? this.getTryPassEndsAt() : null);

        if (code) return resolve({ code, endsAt });
        if (Date.now() - t0 > maxMs) return resolve({ code: null, endsAt: null });
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  updateTryPassColors(essenceKey) {
    const essenceData = this.essenceDescriptions[essenceKey];
    if (!essenceData) return;

    const headlineSpan = document.querySelector('.try-pass__headline span');
    if (headlineSpan) {
      headlineSpan.style.color = essenceData.color;
    }

    const card = document.querySelector('.try-pass__card');
    if (card) {
      card.style.backgroundColor = essenceData.color;
      card.style.color = essenceData.textColor;
    }

    const btn = document.querySelector('.try-pass__cta');
    if (btn) {
      btn.style.backgroundColor = essenceData.color;
      btn.style.borderColor = essenceData.color;
      btn.style.color = essenceData.textColor;
    }

    const headingSpan = document.querySelector('.try-pass__heading span');
    if (headingSpan) {
      headingSpan.style.color = essenceData.color;
    }

    const timerEl = document.querySelector('.try-pass__timer');
    if (timerEl) {
      timerEl.style.backgroundColor = essenceData.color;
    }

    const capsuleTitle = document.querySelector('.capsule-pass__title');
    if (capsuleTitle) {
      capsuleTitle.style.color = essenceData.textColor ?? essenceData.color;
    }

    document.querySelectorAll('.capsule-pass__btn')
      .forEach(btn => {
        btn.style.backgroundColor = essenceData.color;
        btn.style.borderColor = essenceData.color;
        btn.style.color = essenceData.textColor || '#fff';
      });

    document.querySelectorAll('.capsule-pass__code')
      .forEach(el => {
        el.style.color = essenceData.color;
      });

    document.querySelectorAll('.capsule-pass svg rect')
      .forEach(rect => {
        rect.style.setProperty('stroke', essenceData.color, 'important');
      });


  }



  createResultChart(primaryEssence, secondaryEssence, primaryPercent, secondaryPercent) {
    const ctx = document.getElementById('essence-chart');
    if (!ctx) return;
  
    const essenceData = this.essenceDescriptions;
    
    const chartData = [];
    const chartLabels = [];
    const chartColors = [];
    
    if (secondaryEssence && secondaryPercent > 0) {
      // Dual result - proportional distribution to 100%
      const totalPercent = primaryPercent + secondaryPercent;
      const adjustedPrimaryPercent = Math.round((primaryPercent / totalPercent) * 100);
      const adjustedSecondaryPercent = 100 - adjustedPrimaryPercent;
      
      // Calculate display percentages (proportional to 100%)
      const displayPrimaryPercent = adjustedPrimaryPercent;
      const displaySecondaryPercent = adjustedSecondaryPercent;
      
      chartData.push(adjustedPrimaryPercent, adjustedSecondaryPercent);
      chartLabels.push(
        `${displayPrimaryPercent}% ${essenceData[primaryEssence].name}`,
        `${displaySecondaryPercent}% ${essenceData[secondaryEssence].name}`
      );
      chartColors.push(
        essenceData[primaryEssence].color,
        essenceData[secondaryEssence].color
      );
    } else {
      // Single result - show essence + Other to make 100%
      chartData.push(primaryPercent, 100 - primaryPercent);
      chartLabels.push(
        `${primaryPercent}% ${essenceData[primaryEssence].name}`,
        `${100 - primaryPercent}% The silence of you`
      );
      chartColors.push(
        essenceData[primaryEssence].color,
        '#f0f0f0'
      );
    }
  
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartLabels,
        datasets: [{
          data: chartData,
          backgroundColor: chartColors,
          borderWidth: 0,
          cutout: '85%'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        rotation: 180, // Start from left side
        animation: {
          duration: 1500,
          easing: 'easeOutQuart'
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'center',
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              pointStyleWidth: 20,
              pointStyleHeight: 12,
              padding: 20,
              font: {
                size: 14,
                weight: 'bold'
              },
  
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleColor: '#ffffff',
            bodyColor: '#ffffff',
            filter: function(tooltipItem) {
              return !tooltipItem.label.includes('The silence of you');
            },
            callbacks: {
              label: function(context) {
              if (context.label.includes('The silence of you')) return null;
                return context.label;
              }
            }
          }
        }
      }
    });
  }
  
  updateChartInfoSection(primaryEssence, secondaryEssence, primaryPercent, secondaryPercent) {
    const essenceData = this.essenceDescriptions;
    
    // Update title - NO PERCENTAGES
    const combinationTitle = document.querySelector('.chart-essence-combination-title');
    if (combinationTitle) {
      if (secondaryEssence && secondaryPercent > 0) {
        // Dual title with different colors for each essence
        combinationTitle.innerHTML = `<span style="color: ${essenceData[primaryEssence].color};">${essenceData[primaryEssence].name}</span> <span style="color: ${essenceData[primaryEssence].color};">&</span> <span style="color: ${essenceData[secondaryEssence].color};">${essenceData[secondaryEssence].name}</span>`;
      } else {
        // Single title
        combinationTitle.innerHTML = essenceData[primaryEssence].name;
        combinationTitle.style.color = essenceData[primaryEssence].color;
      }
    }
    
    const descriptionText = document.querySelector('.chart-essence-description-text');
    const traitsContainer = document.querySelector('.chart-essence-traits-buttons');
    
    let description = '';
    let traits = [];
    
    if (secondaryEssence && secondaryPercent > 0) {
      const combination1 = `${primaryEssence}_${secondaryEssence}`;
      const combination2 = `${secondaryEssence}_${primaryEssence}`;
      const dualData = this.dualCombinations[combination1] || this.dualCombinations[combination2];
      
      if (dualData) {
        description = dualData.description;
        traits = dualData.traits;
      } else {
        description = `A unique combination of ${essenceData[primaryEssence].name.toLowerCase()} and ${essenceData[secondaryEssence].name.toLowerCase()}.<br><br><br>This means she resonates with:`;
        traits = [...(essenceData[primaryEssence].chartSingleTraits || []).slice(0,2), 
                 ...(essenceData[secondaryEssence].chartSingleTraits || []).slice(0,2)];
      }
    } else {
      // Single essence
      description = essenceData[primaryEssence].chartSingleDescription;
      traits = essenceData[primaryEssence].chartSingleTraits;
    }
    
    // Update description
    if (descriptionText) {
      descriptionText.innerHTML = description;
    }
    
    // Update traits buttons
    if (traitsContainer) {
      traitsContainer.innerHTML = traits.map(trait => 
        `<div class="chart-essence-trait-button">
          ${trait}
        </div>`
      ).join('');
    }
  }

  updateEssenceDescriptionSection(primaryEssence, secondaryEssence, primaryPercent, secondaryPercent) {
    const essenceData = this.essenceDescriptions[primaryEssence];
    
    let titleLine1 = '';
    let titleLine2 = '';
    let traits = [];
    let imageUrl = '';
    
    if (secondaryEssence && secondaryPercent > 0) {
      // Dual result - get data from dualCombinations
      const combination1 = `${primaryEssence}_${secondaryEssence}`;
      const combination2 = `${secondaryEssence}_${primaryEssence}`;
      const dualData = this.dualCombinations[combination1] || this.dualCombinations[combination2];
      
      if (dualData) {
        titleLine1 = dualData.descriptionTitleLine1;
        titleLine2 = dualData.descriptionTitleLine2;
        traits = dualData.descriptionTraits;
        imageUrl = dualData.descriptionImage;
      } else {
        // Fallback to primary essence data
        titleLine1 = essenceData.descriptionTitleLine1;
        titleLine2 = essenceData.descriptionTitleLine2;
        traits = essenceData.descriptionTraits;
        imageUrl = essenceData.descriptionImage;
      }
    } else {
      // Single result
      titleLine1 = essenceData.descriptionTitleLine1;
      titleLine2 = essenceData.descriptionTitleLine2;
      traits = essenceData.descriptionTraits;
      imageUrl = essenceData.descriptionImage;
    }
    
    // Update title
    const titleLine1El = document.querySelector('.title-line-1');
    const titleLine2El = document.querySelector('.title-line-2');
    
    if (titleLine1El) titleLine1El.textContent = titleLine1;
    if (titleLine2El) {
      titleLine2El.textContent = titleLine2;
      titleLine2El.style.color = essenceData.color;
    }
    
    // Update traits
    const traitsContainer = document.querySelector('.essence-description-traits');
    if (traitsContainer) {
      traitsContainer.innerHTML = traits.map(trait => 
        `<div class="chart-essence-trait-button">${trait}</div>`
      ).join('');
    }

    const mobileButton = document.querySelector('.essence-description-button.mobile-only');
    const desktopButton = document.querySelector('.essence-description-button.desktop-only');
    
    if (mobileButton) {
      mobileButton.innerHTML = 'See Your Personalized Collection';
      mobileButton.style.backgroundColor = essenceData.color;
      const textColor = primaryEssence === 'serenity' ? '#222222' : '#FFFFFF';
      mobileButton.style.color = textColor;
      mobileButton.onclick = () => {
        this.scrollToFirstCollection();
      };
    }
    
    if (desktopButton) {
      desktopButton.innerHTML = 'See Your Personalized Collection';
      desktopButton.style.backgroundColor = essenceData.color;
      const textColor = primaryEssence === 'serenity' ? '#222222' : '#FFFFFF';
      desktopButton.style.color = textColor;
      desktopButton.onclick = () => {
        this.scrollToFirstCollection();
      };
    }
          
      const mobileImage = document.querySelector('.essence-description-image.mobile-only .essence-description-img');
      const desktopImage = document.querySelector('.essence-description-image.desktop-only .essence-description-img');
      
      if (mobileImage && imageUrl) {
        mobileImage.src = imageUrl;
        mobileImage.alt = `${essenceData.name} Style`;
      }
      
      if (desktopImage && imageUrl) {
        desktopImage.src = imageUrl;
        desktopImage.alt = `${essenceData.name} Style`;
      }
      
      const generalImage = document.querySelector('.essence-description-img');
      if (generalImage && imageUrl && !mobileImage && !desktopImage) {
        generalImage.src = imageUrl;
        generalImage.alt = `${essenceData.name} Style`;
      }
  }
  
  styleCTASection(essenceKey) {
    const essenceData = this.essenceDescriptions[essenceKey];
    if (!essenceData) return;
    
    const ctaTitle = document.querySelector('.cta-title');
    if (ctaTitle) {
        ctaTitle.style.color = essenceData.color;
    }

    const ctaDescription = document.querySelector('.cta-description');
    if (ctaDescription) {
        ctaDescription.textContent = essenceData.ctaDescription;
    }
    
    const ctaButton = document.querySelector('.cta-button');
    if (ctaButton) {
        ctaButton.style.backgroundColor = essenceData.color;
        ctaButton.style.borderColor = essenceData.color;
        
        const textColor = essenceKey === 'serenity' ? '#000000' : '#FFFFFF';
        ctaButton.style.color = textColor;
    }
  }

  renderTryPassUI(code, endsAtISO) {
    const root = document.querySelector('.try-pass');
    if (!root) { console.warn('[TRY PASS] .try-pass not found'); return; }
    if (!code) { console.warn('[TRY PASS] no code passed into renderTryPassUI'); return; }

    root.querySelectorAll('.try-pass__code').forEach(el => el.textContent = code);

    if (!root._tpBound) {
      root.addEventListener('click', (e) => {
        const t = e.target.closest('.try-pass__cta, .try-pass__card, .try-pass__code');
        if (!t) return;

        e.preventDefault();
        e.stopPropagation();

        console.log('[TRY PASS] click', { code });

        navigator.clipboard.writeText(code)
          .then(() => console.log('[TRY PASS] clipboard OK', code))
          .catch(err => console.warn('[TRY PASS] clipboard FAIL', err))
          .finally(() => {
            const help = root.querySelector('.try-pass__help');
            if (help) {
              if (!help.dataset._orig) help.dataset._orig = help.textContent || '';
              help.textContent = 'Copied ✓';
              setTimeout(() => { help.textContent = help.dataset._orig || ''; }, 1200);
            }
            if (typeof this.flashCopy === 'function') this.flashCopy(t);
          });

        if (window.applyDiscountCodeFromTryPass) {
          console.log('[TRY PASS] applyDiscountCodeFromTryPass', code);
          window.applyDiscountCodeFromTryPass?.(code, { open: false, noRedirect: true });
        } else {
          console.warn('[TRY PASS] applyDiscountCodeFromTryPass missing — redirect fallback');
          const back = location.pathname + location.search +
            (location.search.includes('?') ? '&' : '?') + 'openCart=1&promoApplied=1';
          location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(back)}`;
        }
      }, { passive: false });

      root._tpBound = true;
    }

    const timerEl = root.querySelector('.try-pass__timer');
    if (timerEl && endsAtISO) {
      const tick = () => {
        const left = new Date(endsAtISO).getTime() - Date.now();
        timerEl.textContent = formatHMS(left);
        if (left <= 0) timerEl.textContent = '00:00:00';
      };
      tick();
      const iv = setInterval(tick, 1000);
      root._tpTimer = iv;
    }
  }


  renderTryPassError(err) {
    const root = document.querySelector('.try-pass');
    if (!root) return;
    const codeEl = root.querySelector('.try-pass__code');
    const timerEl = root.querySelector('.try-pass__timer');
    if (codeEl) codeEl.textContent = '— — —';
    if (timerEl) timerEl.textContent = '— — —';
    const help = root.querySelector('.try-pass__help');
    if (help) help.textContent = 'Error creating code';
    console.error(err);
  }

  flashCopy(targetEl) {
    const isCard = targetEl.classList.contains('try-pass__card');
    if (isCard) {
      const help = targetEl.querySelector('.try-pass__help');
      if (!help) return;
      const old = help.textContent;
      help.textContent = 'Copied ✓';
      setTimeout(()=> help.textContent = old, 1200);
    } else {
      const old = targetEl.textContent;
      targetEl.textContent = 'Copied ✓';
      setTimeout(()=> targetEl.textContent = old, 1200);
    }
  }

  pushTryPassToKlaviyo(code, endsAt) {
    if (typeof window.sendQuizCompletionToKlaviyo !== 'function') return;
    window.sendQuizCompletionToKlaviyo({
      quiz_completion: 'try_pass_issued',
      try_pass_code: code,
      try_pass_expires_at: window.formatKlaviyoDate(endsAt)
    });
  }

  
  displayResults(primary, secondary, primaryPercent, secondaryPercent) {
    document.querySelector('.quiz-step[data-step="11"]').classList.remove('hidden');
    
    const primaryData = this.essenceDescriptions[primary];
    const secondaryData = this.essenceDescriptions[secondary];
    
    this.updateElement('.essence-code-top-right', primaryData.topRightText);
    this.updateElement('.left-column .essence-name', primaryData.name);
    this.updateElement('.left-column .percentage', `${primaryPercent}% ${primaryData.name}`);
    this.updateElement('.left-column .description', primaryData.mainDescription);
    this.updateElement('.right-column .top-description', secondaryData.topRightText);
    this.updateElement('.right-column .essence-name', secondaryData.name);
    this.updateElement('.right-column .percentage', `${secondaryPercent}% ${secondaryData.name}`);
    
    this.setElementColor('.left-column .essence-name', primaryData.color);
    this.setElementColor('.right-column .essence-name', secondaryData.color);
    this.updatePrimaryColorCSS(primaryData.color, secondaryData.color);
    this.updateDetailedSections(primaryData, secondaryData);
  }

  updateElement(selector, content) {
    const element = document.querySelector(selector);
    if (element) {
      element.innerHTML = content;
    }
  }

  setElementColor(selector, color) {
    const element = document.querySelector(selector);
    if (element) {
      element.style.color = color;
    }
  }

  updatePrimaryColorCSS(primaryColor, secondaryColor) {
    const style = document.createElement('style');
    style.textContent = `
        .left-column .essence-name::after { 
            background: ${primaryColor} !important; 
        }
        .right-column .essence-name::after { 
            background: ${secondaryColor} !important; 
        }
    `;
    document.head.appendChild(style);
  }

  updateDetailedSections(primaryData, secondaryData) {
      this.updateElement('.primary-name', `${primaryData.name}.`);
      this.setElementColor('.primary-name', primaryData.color);
      this.updateElement('.secondary-name', `${secondaryData.name}.`);
      this.setElementColor('.secondary-name', secondaryData.color); 
      this.updateElement('.primary-traits', primaryData.sheIsTraits);
      this.updateElement('.collection-label', `${primaryData.name} COLLECTION`);
  
      const collectionLabel = document.querySelector('.collection-label:not(.right-collection-label)');
      if (collectionLabel) {
          if (window.innerWidth <= 768) {
              collectionLabel.style.backgroundColor = primaryData.color;
              collectionLabel.style.backgroundImage = 'none';
              collectionLabel.style.color = '#FFFCF0';
          } else {
              collectionLabel.style.backgroundColor = 'transparent';
              collectionLabel.style.backgroundImage = ''; 
              collectionLabel.style.color = primaryData.color;
          }
      }
  
      this.updateElement('.right-collection-label', `${secondaryData.name} COLLECTION`);
      this.updateElement('.center-description', secondaryData.centerDescription);
      this.updateElement('.secondary-name', `${secondaryData.name}.`);
      this.updateElement('.bottom-description', secondaryData.bottomDescription);
      this.updateElement('.secondary-right-text', secondaryData.rightText);
    
      this.updateElement('.also-text-middle', secondaryData.dualTexts.alsoTextMiddle);
      this.updateElement('.mobile-text-left', primaryData.dualTexts.alsoTextMiddle);
      
      this.updateElement('.center-description', secondaryData.dualTexts.centerDescription);
      this.updateElement('.mobile-text-center', primaryData.dualTexts.centerDescription);
      
      this.updateElement('.bottom-description', secondaryData.dualTexts.bottomDescription);
      this.updateElement('.mobile-text-right', primaryData.dualTexts.bottomDescription);
      
      const secondaryLabel = document.querySelector('.right-collection-label');
      if (secondaryLabel) {
          if (window.innerWidth <= 768) {
              secondaryLabel.style.backgroundColor = secondaryData.color;
              secondaryLabel.style.backgroundImage = 'none';
              secondaryLabel.style.color = '#FFFCF0';
          } else {
              secondaryLabel.style.backgroundColor = 'transparent';
              secondaryLabel.style.backgroundImage = '';
              secondaryLabel.style.color = secondaryData.color;
          }
      }
      
      this.updateElement('.collection-title', primaryData.name);
      this.updateElement('.primary-collection-button', `${primaryData.name} COLLECTION'S`);
  }
  
  handleResize() {
      const isDualResult = document.querySelector('.dual-essence-result');
      if (!isDualResult) return;
      
      const primaryData = this.essenceDescriptions[isDualResult.getAttribute('data-primary-essence')];
      const secondaryData = this.essenceDescriptions[isDualResult.getAttribute('data-secondary-essence')];
      
      if (primaryData && secondaryData) {
          const collectionLabel = document.querySelector('.collection-label:not(.right-collection-label)');
          const secondaryLabel = document.querySelector('.right-collection-label');
          
          if (collectionLabel) {
              if (window.innerWidth <= 768) {
                  collectionLabel.style.backgroundColor = primaryData.color;
                  collectionLabel.style.backgroundImage = 'none';
                  collectionLabel.style.color = '#FFFCF0';
              } else {
                  collectionLabel.style.backgroundColor = 'transparent';
                  collectionLabel.style.backgroundImage = '';
                  collectionLabel.style.color = primaryData.color;
              }
          }
          
          if (secondaryLabel) {
              if (window.innerWidth <= 768) {
                  secondaryLabel.style.backgroundColor = secondaryData.color;
                  secondaryLabel.style.backgroundImage = 'none';
                  secondaryLabel.style.color = '#FFFCF0';
              } else {
                  secondaryLabel.style.backgroundColor = 'transparent';
                  secondaryLabel.style.backgroundImage = '';
                  secondaryLabel.style.color = secondaryData.color;
              }
          }
      }
      
      const leftEssenceName = document.querySelector('.left-column .essence-name');
      const rightEssenceName = document.querySelector('.right-column .essence-name');
      
      if (leftEssenceName && leftEssenceName.textContent.includes('TIMELESS GRACE')) {
          leftEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      }
      
      if (rightEssenceName && rightEssenceName.textContent.includes('TIMELESS GRACE')) {
          rightEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      }
  }

  loadProducts(primary, secondary) {
    const container = document.getElementById('essence-products-container');
    container.innerHTML = '';
  
    const collectionMap = {
      confidence: ['confidence-capsule-1', 'confidance-capsule-2'], 
      serenity: ['serenity-capsule-1', 'serenity-capsule-2'],
      passion: ['passion-capsule-1', 'passion-capsule-2'], 
      timeless_elegance: ['the-eternal-one', 'the-pure-one']
    };
  
    const primaryData = this.essenceDescriptions[primary];
    const secondaryData = this.essenceDescriptions[secondary];
  
    this.createCollectionSlider(container, primary, primaryData, collectionMap[primary], true);
  
    this.createCollectionSlider(container, secondary, secondaryData, collectionMap[secondary], false);
  }

  createCollectionSlider(container, essenceKey, essenceData, capsules, isPrimary) {
    this.createCollectionHeader(container, essenceKey, essenceData, false);

    const sectionId = `${essenceKey}-collection-section`;
    const currentSection = container.querySelector('.collection-slider-section:last-child');
    if (currentSection) {
        currentSection.id = sectionId;
    }
  
    capsules.forEach((capsuleId, index) => {
      const capsuleData = document.getElementById(capsuleId);
      if (!capsuleData) return;
  
      const products = JSON.parse(capsuleData.textContent).products;
      if (products.length === 0) return;
  
      const capsuleNumber = index + 1;
      
      const capsuleInfo = essenceData.capsules[capsuleId];
      
      if (!capsuleInfo) {
        console.error('Capsule info not found for:', capsuleId);
        return;
      }
      
      const sliderSection = document.createElement('div');
      sliderSection.className = 'essence-slider-wrapper dual-essence-slider';
      sliderSection.setAttribute('data-essence', essenceKey);
      sliderSection.setAttribute('data-capsule', capsuleNumber);
      sliderSection.setAttribute('data-dual-result', 'true');
      sliderSection.innerHTML = `
        <div class="slider-content">
          <div class="slider-description">
            <div class="collection-description-top">
              ${capsuleInfo.title}
            </div>
            
            <div class="wear-text">${capsuleInfo.description}</div>
          </div>
          
          <div class="products-slider-container">
            <div class="scroll-buttons">
              <button class="scroll-btn left" name="previous" data-slider="${essenceKey}-${capsuleNumber}">
                <svg width="44" height="8" viewBox="0 0 44 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM44 3.5H1V4.5H44V3.5Z" fill="black"/>
                </svg>
              </button>
              <button class="scroll-btn right" name="next" data-slider="${essenceKey}-${capsuleNumber}">
                <svg width="44" height="8" viewBox="0 0 44 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M43.3536 4.35355C43.5488 4.15829 43.5488 3.84171 43.3536 3.64645L40.1716 0.464466C39.9763 0.269204 39.6597 0.269204 39.4645 0.464466C39.2692 0.659728 39.2692 0.976311 39.4645 1.17157L42.2929 4L39.4645 6.82843C39.2692 7.02369 39.2692 7.34027 39.4645 7.53553C39.6597 7.7308 39.9763 7.7308 40.1716 7.53553L43.3536 4.35355ZM0 4.5H43V3.5H0V4.5Z" fill="black"/>
              </svg>
            </button>
          </div>
          
          <div class="products-slider-viewport">
            <div class="products-slider" id="slider-${essenceKey}-${capsuleNumber}">
              <div class="products-track">
                ${products.map(product => this.getProductCardHTML(product, essenceKey, essenceData)).join('')}
              </div>
            </div>
          </div>
        </div>
      `;
  
      container.appendChild(sliderSection);
      
      setTimeout(() => {
        this.initializeSlider(`slider-${essenceKey}-${capsuleNumber}`);

        document.dispatchEvent(new Event('DOMContentLoaded'));
        
        const labels = sliderSection.querySelectorAll('.essence-label');
        const style = this.getEssenceLabelStyle(essenceKey);
        labels.forEach(label => {
          label.style.borderColor = style.borderColor;
          label.style.color = style.color;
        });
        
        const buttons = sliderSection.querySelectorAll('.quick-add__submit');
          buttons.forEach(button => {
          button.style.backgroundColor = essenceData.color;
          button.style.borderColor = essenceData.color;
          const textColor = essenceKey === 'serenity' ? '#222222' : '#FFFFFF';
          button.style.color = textColor;
        });

        const descriptionSpans = sliderSection.querySelectorAll('.collection-description-top span');
        descriptionSpans.forEach(span => {
            span.style.color = essenceData.color;
        });
                
      }, 100);
    });
  }

  createSingleCapsuleSlider(container, essenceKey, essenceData, capsuleId, capsuleNumber, products, capsuleInfo) {
    const sliderSection = document.createElement('div');
    sliderSection.className = 'essence-slider-wrapper single-essence-slider';
    sliderSection.setAttribute('data-essence', essenceKey);
    sliderSection.setAttribute('data-capsule', capsuleNumber);
    sliderSection.setAttribute('data-single-result', 'true');
  
    sliderSection.innerHTML = `
      <div class="slider-content single-essence-content" data-essence="${essenceKey}">
        <div class="slider-description single-essence-description" data-essence="${essenceKey}">
          <div class="collection-description-top">
            ${capsuleInfo.title}
          </div>
          <div class="wear-text single-essence-wear-text">${capsuleInfo.description}</div>
        </div>
        
        <div class="products-slider-container"> 
          <div class="scroll-buttons">
            <button class="scroll-btn left disabled" name="previous" data-slider="${essenceKey}-${capsuleNumber}">
              <svg width="44" height="8" viewBox="0 0 44 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM44 3.5H1V4.5H44V3.5Z" fill="black"/>
              </svg>
            </button>
            <button class="scroll-btn right" name="next" data-slider="${essenceKey}-${capsuleNumber}">
              <svg width="44" height="8" viewBox="0 0 44 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M43.3536 4.35355C43.5488 4.15829 43.5488 3.84171 43.3536 3.64645L40.1716 0.464466C39.9763 0.269204 39.6597 0.269204 39.4645 0.464466C39.2692 0.659728 39.2692 0.976311 39.4645 1.17157L42.2929 4L39.4645 6.82843C39.2692 7.02369 39.2692 7.34027 39.4645 7.53553C39.6597 7.7308 39.9763 7.7308 40.1716 7.53553L43.3536 4.35355ZM0 4.5H43V3.5H0V4.5Z" fill="black"/>
              </svg>
            </button>
          </div>
          
          <div class="products-slider-viewport"> 
            <div class="products-slider" id="slider-${essenceKey}-${capsuleNumber}">
              <div class="products-track">
                ${products.map((product, index) => this.getProductCardHTML(product, essenceKey, essenceData, index)).join('')}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  
    container.appendChild(sliderSection);
    
    setTimeout(() => {
      this.initializeSlider(`slider-${essenceKey}-${capsuleNumber}`);

      document.dispatchEvent(new Event('DOMContentLoaded'));
   
      const labels = sliderSection.querySelectorAll('.essence-label');
      const style = this.getEssenceLabelStyle(essenceKey);
      labels.forEach(label => {
        label.style.borderColor = style.borderColor;
        label.style.color = style.color;
      });
      
      const buttons = sliderSection.querySelectorAll('.quick-add__submit');
        buttons.forEach(button => {
        button.style.backgroundColor = essenceData.color;
        button.style.borderColor = essenceData.color;
        const textColor = essenceKey === 'serenity' ? '#222222' : '#FFFFFF';
        button.style.color = textColor;
      });

      const descriptionSpans = sliderSection.querySelectorAll('.collection-description-top span');
      descriptionSpans.forEach(span => {
        span.style.color = essenceData.color;
      });
      
    }, 100);
  }
  
  initializeSlider(sliderId) {
    const slider = document.getElementById(sliderId);
    if (!slider) {
      return;
    }
  
    const track = slider.querySelector('.products-track');
    const viewport = slider.closest('.products-slider-viewport');
    const sliderContainer = viewport ? viewport.closest('.products-slider-container') : null;
    const leftBtn = sliderContainer ? sliderContainer.querySelector('.scroll-btn.left') : null;
    const rightBtn = sliderContainer ? sliderContainer.querySelector('.scroll-btn.right') : null;
  
    if (!track || !viewport || !leftBtn || !rightBtn) {
      return;
    }
  
    const cards = track.children;
    if (cards.length === 0) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
        return;
    }
  
    let currentPosition = 0;
    let cardWidth = 0;
    
    const calculateMetrics = () => {
      const cardStyle = window.getComputedStyle(cards[0]);
      const trackStyle = window.getComputedStyle(track);
      const cardMargin = parseFloat(cardStyle.marginLeft) + parseFloat(cardStyle.marginRight);
      const trackGap = parseFloat(trackStyle.gap) || 0;
      cardWidth = cards[0].offsetWidth + (trackGap || cardMargin);
  
      const totalWidth = track.scrollWidth;
      const viewportWidth = viewport.clientWidth;
      return Math.max(0, totalWidth - viewportWidth);
    };
    
    let maxPosition = calculateMetrics();
  
    const updateButtons = () => {
      leftBtn.disabled = currentPosition <= 0;
      rightBtn.disabled = currentPosition >= maxPosition - 1;
      leftBtn.classList.toggle('disabled', leftBtn.disabled);
      rightBtn.classList.toggle('disabled', rightBtn.disabled);
    };
  
    const slide = (direction) => {
      if (direction === 'left') {
        currentPosition = Math.max(0, currentPosition - cardWidth);
      } else if (direction === 'right') {
        currentPosition = Math.min(maxPosition, currentPosition + cardWidth);
      }
      track.style.transform = `translateX(-${currentPosition}px)`;
      updateButtons();

      const sliderElement = track.closest('.essence-slider-wrapper');
      if (sliderElement && window.essenceQuiz && window.essenceQuiz.analytics) {
        const essence = sliderElement.dataset.essence;
        const capsule = sliderElement.dataset.capsule;
        const position = Math.round(currentPosition / cardWidth);
        
        window.essenceQuiz.analytics.trackSliderInteraction(essence, capsule, direction, position);
      }
      
    };
  
    leftBtn.addEventListener('click', (e) => {
      e.preventDefault();
      slide('left');
    });
    
    rightBtn.addEventListener('click', (e) => {
      e.preventDefault();
      slide('right');
    });
  
    sliderContainer.setAttribute('tabindex', '0');
    sliderContainer.style.outline = 'none';
  
    sliderContainer.addEventListener('keydown', (e) => {
      if (document.activeElement !== sliderContainer) return;
      
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        slide('left');
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        slide('right');
      }
    });
    
    window.addEventListener('resize', () => {
        maxPosition = calculateMetrics();
        if(currentPosition > maxPosition) {
            currentPosition = maxPosition;
            track.style.transform = `translateX(-${currentPosition}px)`;
        }
        updateButtons();
    });
  
    updateButtons();
  }

  getProductCardHTML(product, essenceKey, essenceData, index = 0) {
    const selectedVariant = product.variants[0];
    const compareAtPrice = product.compare_at_price;
    const price = product.price;
    const isOnSale = compareAtPrice > price;
    const productFormId = `quiz-product-${product.id}`;
    
    const productUrl = product.url || `/products/${product.handle}`;
    
    const forceAvailable = true;
    const forceVariantAvailable = true;
    
    return `
    <div class="slider-product-card" 
         data-product-id="${product.id}" 
         data-product-title="${product.title}"
         data-essence="${essenceKey}"
         data-position="${index}">
      <div class="spf-product-card spf-product-card__left spf-product-card__template-1">
        <div class="spf-product-card__inner">
          ${isOnSale ? '<span class="spf-product__label spf-product__label-sale sale-text">Sale</span>' : ''}
          
          <a title="Quick view" href="javascript:;" 
             onclick="openQuickViewWithTracking('${productUrl}', '${product.id}', '${product.title}', '${essenceKey}')" 
             class="open-quick-view">
            <svg width="15" height="15" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M1664 960q-152-236-381-353 61 104 61 225q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"/>
            </svg>
          </a>
          
          <div class="essence-label">${essenceData.name}</div>
          
          <div class="spf-product-card__image-wrapper${product.images && product.images.length > 1 ? ' hover-effect' : ''}" 
               style="padding-top:140%; cursor: pointer;" 
               onclick="openQuickViewWithTracking('${productUrl}', '${product.id}', '${product.title}', '${essenceKey}')">
            ${product.images && product.images.length > 0 ? 
              product.images.map((image, index) => 
                `<img data-variants="${image.variant_ids ? image.variant_ids.join(',') : ''}" 
                      class="spf-product-card__image spf-product-card__image-${index === 0 ? 'main' : (index === 1 ? 'secondary' : 'hidden')}" 
                      src="${typeof image === 'string' ? image : image.src}" 
                      alt="${typeof image === 'object' && image.alt ? image.alt : product.title}" 
                       />`
              ).join('') :
              `<img class="spf-product-card__image spf-product-card__image-main" 
                    src="${product.featured_image || 'https://cdn.shopify.com/s/images/themes/product-1.png'}" 
                    alt="${product.title}" />`
            }
          </div>
        </div>
  
        <div class="spf-product__info">
          ${product.vendor ? `<div class="spf-product-card__vendor"><a href="/collections/vendors?q=${encodeURIComponent(product.vendor)}">${product.vendor}</a></div>` : ''}
          
          <div class="h4 spf-product-card__title" style="display: flex;justify-content: space-between;">
            <a href="javascript:;" onclick="openQuickViewWithTracking('${productUrl}', '${product.id}', '${product.title}', '${essenceKey}')">${product.title}</a>
          </div>
  
          <div class="main-product-info">
            <div data-pl-swatches-collection data-product-id="${product.id}" data-product-url="${productUrl}"></div>
          
            <div class="spf-product-card__price-wrapper">
              ${isOnSale ? 
                `<span class="spf-product-card__oldprice money">${this.formatMoney(compareAtPrice)}</span>
                 <span class="spf-product-card__saleprice money">${this.formatMoney(price)}</span>` :
                `<span class="spf-product-card__price money">${this.formatMoney(price)}</span>`
              }
            </div>
          </div>
  
          <div class="quick-add no-js-hidden">
            <product-form data-section-id="quiz-results">
              <form method="post" action="/cart/add" id="${productFormId}" class="form" data-type="add-to-cart-form">
                <input type="hidden" name="id" value="${selectedVariant.id}" class="product-variant-id">
                <button id="${productFormId}-submit" type="submit" name="add" 
                        onclick="trackAddToCartClick('${product.id}', '${product.title}', '${essenceKey}', ${price})"
                        class="quick-add__submit button button--full-width button--secondary">
                  <span>Add to cart</span>
                  <span class="sold-out-message hidden">Sold out</span>
                  <div class="loading__spinner hidden">
                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </form>
            </product-form>
          </div>
        </div>
      </div>
    </div>`;
  }
  
  hideProgressBar() {
    const progress = document.querySelector('.quiz-progress');
    if (progress) {
      progress.style.display = 'none';
    }
  }
  
  getEssenceLabelStyle(essenceKey) {
    const styles = {
      passion: { borderColor: '#A72831', color: '#222' },
      timeless_elegance: { borderColor: '#376575', color: '#40312E' },
      serenity: { borderColor: '#F0C8D0', color: '#40312E' },
      confidence: { borderColor: '#40312E', color: '#40312E' }
    };
    return styles[essenceKey] || {};
  }
  
  formatEssenceName(name) {
    return name.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
  }

  formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  getRealPercentages() {
    const totalAnswers = Object.values(this.scores).reduce((sum, score) => sum + score, 0);
    
    if (totalAnswers === 0) {
        return {
            confidence: 0,
            passion: 0,
            timeless_elegance: 0,
            serenity: 0
        };
    }
    
    return {
        confidence: Math.round((this.scores.confidence / totalAnswers) * 100),
        passion: Math.round((this.scores.passion / totalAnswers) * 100),
        timeless_elegance: Math.round((this.scores.timeless_elegance / totalAnswers) * 100),
        serenity: Math.round((this.scores.serenity / totalAnswers) * 100)
    };
  }

  sendStepToKlaviyo(step, status = 'step', quizResults = {}) {
      if (!window.quizUserData) return;
  
      let quizCompletion;
      if (status === 'completed') {
          quizCompletion = 'completed';
      } else if (status === 'abandoned') {
          quizCompletion = `abandoned_step_${step}`;
      } else {
          quizCompletion = `step_${step}`;
      }

      const realPercentages = this.getRealPercentages();
  
      window.sendQuizCompletionToKlaviyo({
          quiz_result: quizResults.quiz_result || (status === 'completed' ? this.getQuizResults() : ''),
          quiz_result_primary: quizResults.quiz_result_primary || '',
          quiz_result_secondary: quizResults.quiz_result_secondary || '',
          essence_combination: quizResults.essence_combination || '',
          step: step,
          quiz_completion: quizCompletion,
          quiz_last_step: step,
          real_confidence_percentage: quizResults.real_confidence_percentage ?? realPercentages.confidence,
          real_passion_percentage: quizResults.real_passion_percentage ?? realPercentages.passion,
          real_timeless_percentage: quizResults.real_timeless_percentage ?? realPercentages.timeless_elegance,
          real_serenity_percentage: quizResults.real_serenity_percentage ?? realPercentages.serenity,
          try_pass_code: quizResults.try_pass_code || '',
          try_pass_expires_at: quizResults.try_pass_expires_at || ''
      });
  }

  getQuizResults() {
      const sorted = Object.entries(this.scores).sort((a, b) => b[1] - a[1]);
      const primary = sorted[0];
      const secondary = sorted[1];
      
      const totalAnswers = Object.values(this.scores).reduce((sum, score) => sum + score, 0);
      
      if (totalAnswers === 0) return 'No answers';
      
      const isDominant = primary[1] > 0 && secondary[1] === 0;
      
      if (isDominant) {
          return `100% ${this.formatEssenceName(primary[0])}`;
      } else {
          const primaryPercent = Math.round((primary[1] / totalAnswers) * 100);
          const secondaryPercent = Math.round((secondary[1] / totalAnswers) * 100);
          return `${primaryPercent}% ${this.formatEssenceName(primary[0])} ${secondaryPercent}% ${this.formatEssenceName(secondary[0])}`;
      }
  }
  
  formatEssenceName(essence) {
      const names = {
          confidence: 'Confidence',
          serenity: 'Serenity', 
          passion: 'Passion',
          timeless_elegance: 'Timeless Grace'
      };
      return names[essence] || essence;
  }

  setupCollectionButtonHandlers() {
    document.addEventListener('click', (e) => {
        
      
        if (e.target.classList.contains('collection-button')) {
            e.preventDefault();
            
            let essence = null;
            const section = e.target.closest('[data-essence]');
            if (section) {
                essence = section.getAttribute('data-essence');
            } else {
                essence = this.getEssenceFromButtonText(e.target.textContent);
            }
            
            if (essence) {
                this.scrollToCollection(essence);
            }
        }

        if (e.target.classList.contains('cta-button')) {
            e.preventDefault();
            this.scrollToFirstCollection();
        }
        
        // Collection labels  
        if (e.target.classList.contains('collection-label')) {
            e.preventDefault();
            const essence = this.getEssenceFromLabel(e.target);
            if (essence) {
                this.scrollToCollection(essence);
            }
        }
        
        // Primary collection button
        if (e.target.classList.contains('primary-collection-button')) {
            e.preventDefault();
            const essence = this.getPrimaryEssence();
            if (essence) {
                this.scrollToCollection(essence);
            }
        }
    });
  }

  getEssenceFromButtonText(buttonText) {
      const text = buttonText.toLowerCase();
      
      if (text.includes('confidence')) return 'confidence';
      if (text.includes('serenity')) return 'serenity';  
      if (text.includes('passion')) return 'passion';
      if (text.includes('timeless') || text.includes('grace')) return 'timeless_elegance';
      
      return null;
  }
  
  scrollToCollection(essence) {
      const targetSection = document.getElementById(`${essence}-collection-section`);
      if (targetSection) {
          targetSection.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
          });
      }
  }

  scrollToFirstCollection() {
    const firstCollectionSection = document.querySelector('.collection-slider-section');
    if (firstCollectionSection) {
        firstCollectionSection.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        });
    }
  }
  
  getEssenceFromLabel(labelElement) {
      if (labelElement.classList.contains('right-collection-label')) {
          const container = document.querySelector('.quiz-step[data-step="11"]');
          return container?.getAttribute('data-secondary-essence');
      } else {
          const container = document.querySelector('.quiz-step[data-step="11"]');
          return container?.getAttribute('data-primary-essence') || 
                 container?.getAttribute('data-single-essence');
      }
  }
  
  getPrimaryEssence() {
      const container = document.querySelector('.quiz-step[data-step="11"]');
      return container?.getAttribute('data-primary-essence') || 
             container?.getAttribute('data-single-essence');
  }

  async requestAndRenderTryPass() {
    if (this._tryPassPending) return;
    this._tryPassPending = true;

    const tryPassEl = document.querySelector('.try-pass');
    if (!tryPassEl) { this._tryPassPending = false; return; }

    const codeEl   = tryPassEl.querySelector('.try-pass__code');
    const timerEl  = tryPassEl.querySelector('.try-pass__timer');
    const ctaBtn   = tryPassEl.querySelector('.try-pass__cta');
    const helpEl   = tryPassEl.querySelector('.try-pass__help');
    const codeCard = tryPassEl.querySelector('.try-pass__card');

    if (codeEl)  codeEl.textContent  = '— — —';
    if (timerEl) timerEl.textContent = '--:--:--';
    if (helpEl)  helpEl.textContent  = 'Generating…';

    const stepEl  = document.querySelector('.quiz-step[data-step="11"]');
    const essence = (stepEl?.getAttribute('data-single-essence')) ||
                    (stepEl?.getAttribute('data-primary-essence')) || '';
    const email   = (window.quizUserData && window.quizUserData.email) ? window.quizUserData.email : '';

    try {
      const res = await fetch('/apps/quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quiz_secret: 'Z8x!Qw92$paLm@Vh7Kc3#eRt9Ub^Yj1f', essence, email })
      });

      const json = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error('TRY PASS API error', res.status, json);
        throw new Error(json && json.error ? json.error : `HTTP_${res.status}`);
      }

      const { code, endsAt } = json || {};
      if (!code || !endsAt) throw new Error('invalid_payload');

      if (codeEl) codeEl.textContent = code;
      if (helpEl) helpEl.textContent = 'Once copied, your code appears in your cart';
      if (timerEl) startTryPassCountdown(timerEl, endsAt);

      const attachCopy = (el) => el && el.addEventListener('click', () => {
        copyTextToClipboard(code, () => {
          if (el === ctaBtn) {
            const old = el.textContent;
            el.textContent = 'Copied!';
            setTimeout(() => el.textContent = old, 1200);
          } else if (codeCard) {
            const h = codeCard.querySelector('.try-pass__help');
            if (h) {
              const old = h.textContent;
              h.textContent = 'Copied ✓';
              setTimeout(() => h.textContent = old, 1200);
            }
          }
        });
      });

      attachCopy(ctaBtn);
      attachCopy(codeCard);

      if (typeof window.sendQuizCompletionToKlaviyo === 'function') {
        try {
          window.sendQuizCompletionToKlaviyo({
            quiz_completion: 'try_pass_issued',
            try_pass_code: code,
            try_pass_expires_at: endsAt
          });
        } catch (_) {}
      }

      this.tryPass = { code, endsAt };
      document.dispatchEvent(new CustomEvent('trypass:ready', { detail: { code, endsAt } }));
        console.log('[TRY PASS] dispatched trypass:ready', { code, endsAt });

      } catch (e) {
        console.error('TRY PASS error:', e);
        if (helpEl) helpEl.textContent = 'Minor delay. Try again';
        if (ctaBtn) {
          ctaBtn.textContent = 'Retry';
          ctaBtn.onclick = () => this.requestAndRenderTryPass();
        }
      } finally {
        this._tryPassPending = false;
      }
    }

  }

  window.openQuickView = function(productUrl) {
    if (!productUrl || productUrl === 'undefined' || !productUrl.startsWith('/')) {
      alert('Product URL is not available');
      return;
    }

    if (typeof globofilter !== 'undefined' && typeof globofilter.quickView === 'function') {
      try {
        globofilter.quickView(productUrl);
        return;
      } catch (error) {
      }
    }
    
    createCustomQuickViewModal(productUrl);
  };

  function createCustomQuickViewModal(productUrl) {
    let existingModal = document.getElementById('custom-quick-view-modal');
    if (existingModal) {
      existingModal.remove();
    }
    
    const modal = document.createElement('div');
    modal.id = 'custom-quick-view-modal';
    
    const modalContent = document.createElement('div');
    modalContent.className = 'quick-view-modal-content';
    
    modalContent.innerHTML = `
      <button onclick="this.closest('#custom-quick-view-modal').remove(); document.body.classList.remove('overflow-hidden');" 
              class="quick-view-close-btn">×</button>
      <div class="quick-view-loading">
        <div class="quick-view-loading-text">Loading product details...</div>
        <div class="quick-view-spinner"></div>
      </div>
    `;
    
    modal.onclick = (e) => {
      if (e.target === modal) {
        modal.remove();
        document.body.classList.remove('overflow-hidden');
      }
    };
    
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
    document.body.classList.add('overflow-hidden');
    
    fetchProductContent(productUrl, modalContent);
  }

  function fetchProductContent(productUrl, container) {

    Promise.all([
      fetch(productUrl + '.js').then(response => response.json()),
      fetch(productUrl).then(response => response.text())
    ])
      .then(([product, htmlContent]) => {
        const firstVariant = product.variants[0];
        
        // Parse HTML to extract additional data
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        let productSubtitle = '';
        const subtitleDiv = doc.querySelector('.rte.product-subtitle');
        if (subtitleDiv) {
          productSubtitle = subtitleDiv.innerHTML.trim();
        } else {
          const fallbackSubtitle = doc.querySelector('.product-subtitle p');
          if (fallbackSubtitle) {
            productSubtitle = fallbackSubtitle.innerHTML.trim();
          }
        }
        console.log('Final productSubtitle:', productSubtitle);
        
        // Extract rating data
        const ratingElement = doc.querySelector('.loox-rating');
        let ratingHtml = '';
        if (ratingElement) {
          ratingHtml = `<div class="quick-view-rating">${ratingElement.outerHTML}</div>`;
        }
        
        // Extract swatches data - FORCE collection swatches for visual display
        const collectionSwatchesElement = doc.querySelector('[data-pl-swatches-collection]');
        let swatchesHtml = '';
        
        if (collectionSwatchesElement) {
          swatchesHtml = `<div class="quick-view-swatches">${collectionSwatchesElement.outerHTML}</div>`;
        } else {
          // If no collection swatches, try to find them in script or fallback
          console.log('No collection swatches found, looking for alternatives...');
          const regularSwatchesElement = doc.querySelector('.pl-swatches');
          if (regularSwatchesElement) {
            swatchesHtml = `<div class="quick-view-swatches">${regularSwatchesElement.outerHTML}</div>`;
          }
        }
        
        // Extract variant selects (sizes)
        const variantSelectsElement = doc.querySelector('variant-selects');
        let variantSelectsHtml = '';
        if (variantSelectsElement) {
          const fieldsets = variantSelectsElement.querySelectorAll('fieldset');
          fieldsets.forEach(fieldset => {
            const legend = fieldset.querySelector('legend');
            const inputs = fieldset.querySelectorAll('input[type="radio"]');
            if (legend && inputs.length > 0) {
              variantSelectsHtml += `
                <div class="quick-view-variant-select">
                  <div class="variant-label">${legend.textContent}</div>
                  <div class="variant-options">
                    ${Array.from(inputs).map(input => {
                      const label = fieldset.querySelector(`label[for="${input.id}"]`);
                      let labelText = input.value;
                      if (label) {
                        let cleanText = label.textContent || label.innerText || '';
                        cleanText = cleanText.replace(/Variant sold out or unavailable/gi, '');
                        cleanText = cleanText.replace(/\s+/g, ' ').trim();
                        labelText = cleanText && cleanText !== input.value ? cleanText : input.value;
                      }
                      return `
                        <input type="radio" id="qv-${input.id}" name="qv-${input.name}" value="${input.value}" ${input.checked ? 'checked' : ''}>
                        <label for="qv-${input.id}">${labelText}</label>
                      `;
                    }).join('')}
                  </div>
                </div>
              `;
            }
          });
        }
        
      // Extract accordion data
      const accordionElements = doc.querySelectorAll('.product__accordion details');
      let accordionHtml = '';
      if (accordionElements.length > 0) {
        accordionHtml = `
          <div class="quick-view-accordion">
            ${Array.from(accordionElements)
              .filter(detail => {
                const title = detail.querySelector('.accordion__title');
                return !(title && title.textContent.trim().toUpperCase() === 'MATERIALS');
              })
              .map(detail => {
                const title = detail.querySelector('.accordion__title');
                const content = detail.querySelector('.accordion__content');
                return `
                  <details class="quick-view-accordion-item">
                    <summary class="quick-view-accordion-summary">
                      <div class="accordion-title">${title ? title.innerHTML : 'Details'}</div>
                      <span class="accordion-icon">
                        <svg class="icon-closed" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.64 11.344V0.735999H6.752V11.344H4.64ZM0.104 7.048V5.032H11.312V7.048H0.104Z" fill="black"/>
                        </svg>
                        <svg class="icon-open" width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                          <path d="M0.776 2.928V0.912H10.472V2.928H0.776Z" fill="black"/>
                        </svg>
                      </span>
                    </summary>
                    <div class="quick-view-accordion-content">
                      ${content ? content.innerHTML : ''}
                    </div>
                  </details>
                `;
              }).join('')}
          </div>
        `;
      }


        // Create main gallery HTML with thumbnails
        let galleryHtml = '';
        let thumbnailsHtml = '';
        
        if (product.images && product.images.length > 0) {
          // Main image
          galleryHtml = `
            <div class="quick-view-main-image">
              <img id="qv-main-image" src="${product.images[0]}" alt="${product.title}">
            </div>
          `;
          
          // Thumbnails
          if (product.images.length > 1) {
            thumbnailsHtml = `
              <div class="quick-view-thumbnails">
                ${product.images.map((imageUrl, index) => `
                  <div class="qv-thumbnail ${index === 0 ? 'active' : ''}" data-image="${imageUrl}">
                    <img src="${imageUrl}" alt="${product.title}">
                  </div>
                `).join('')}
              </div>
            `;
          }
        } else if (product.featured_image) {
          galleryHtml = `
            <div class="quick-view-main-image">
              <img id="qv-main-image" src="${product.featured_image}" alt="${product.title}">
            </div>
          `;
        }

        container.innerHTML = `
          <button onclick="this.closest('#custom-quick-view-modal').remove(); document.body.classList.remove('overflow-hidden');"
            class="quick-view-close-btn">×</button>
          
          <div class="quick-view-content">
            <div class="quick-view-gallery">
              ${galleryHtml}
              ${thumbnailsHtml}
            </div>
            
            <div class="quick-view-details">
              <h2 class="quick-view-title">${product.title}</h2>
              ${ratingHtml}
              <div class="quick-view-price">£${(firstVariant.price / 100).toFixed(2)}</div>

              <div class="quick-view-description">
                ${productSubtitle || ''}    
              </div>
              
              ${swatchesHtml}
              ${variantSelectsHtml}
              
              <div class="quick-add no-js-hidden">
                <product-form data-section-id="quick-view-results">
                  <form method="post" action="/cart/add" id="qv-product-form" class="form quick-view-form" data-type="add-to-cart-form">
                    <input type="hidden" name="id" value="${firstVariant.id}" class="product-variant-id" ${!firstVariant.available ? 'disabled' : ''}>
                    <button id="qv-product-form-submit" type="submit" name="add"
                            onclick="if(window.essenceQuiz?.analytics) window.essenceQuiz.analytics.trackAddToCart('popup', 'popup', 'popup', 0)"
                            class="quick-add__submit button button--full-width button--secondary quick-view-add-btn" 
                            ${!firstVariant.available ? 'disabled' : ''}>
                      <span>${firstVariant.available ? 'Add to cart' : 'Sold out'}</span>
                      <span class="sold-out-message hidden">Sold out</span>
                      <div class="loading__spinner hidden">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </form>
                </product-form>
              </div>
              
              ${accordionHtml}
            </div>
          </div>
        `;

        // Add thumbnail click handlers
        const thumbnails = container.querySelectorAll('.qv-thumbnail');
        const mainImage = container.querySelector('#qv-main-image');
        
        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', function() {
            const imageUrl = this.dataset.image;
            if (mainImage && imageUrl) {
              mainImage.src = imageUrl;
              
              // Update active thumbnail
              thumbnails.forEach(t => t.classList.remove('active'));
              this.classList.add('active');
            }
          });
        });

        // Add swatch handlers - handle both collection and regular swatches
        const swatchLinks = container.querySelectorAll('.pl-swatches__link, .pl-swatches-collection__link');
        swatchLinks.forEach(link => {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Get handle from href or data-handle
            const href = this.getAttribute('href');
            let handle = this.dataset.handle;
            
            if (!handle && href && href.startsWith('/products/')) {
              handle = href.replace('/products/', '');
            }
            
            if (handle && handle !== product.handle) {
              // Load new product data
              loadSwatchProduct(handle, container);
            }
            
            // Update active swatch for both types
            const swatchContainer = this.closest('.pl-swatches__container, .pl-swatches-collection__container');
            if (swatchContainer) {
              const wrapperClass = this.classList.contains('pl-swatches__link') ? 
                '.pl-swatches__swatch-wrapper' : '.pl-swatches-collection__swatch-wrapper';
              const activeClass = this.classList.contains('pl-swatches__link') ? 
                'pl-swatches__swatch-wrapper--active' : 'pl-swatches-collection__swatch-wrapper--active';
                
              swatchContainer.querySelectorAll(wrapperClass).forEach(wrapper => {
                wrapper.classList.remove(activeClass);
              });
              this.querySelector(wrapperClass).classList.add(activeClass);
            }
          });
        });

        // Add variant select handlers
        const variantRadios = container.querySelectorAll('.variant-options input[type="radio"]');
        variantRadios.forEach(radio => {
          radio.addEventListener('change', function() {
            const selectedOptions = Array.from(container.querySelectorAll('.variant-options input[type="radio"]:checked'))
              .map(input => input.value);
            
            // Find matching variant
            const matchingVariant = product.variants.find(variant => {
              return selectedOptions.every(option => 
                variant.option1 === option || variant.option2 === option || variant.option3 === option
              );
            });
            
            if (matchingVariant) {
              container.querySelector('#qv-variant-id').value = matchingVariant.id;
              container.querySelector('.quick-view-price').textContent = `£${(matchingVariant.price / 100).toFixed(2)}`;
            }
          });
        });

      })
      .catch(error => {
        container.innerHTML = `
          <div class="quick-view-loading">
            <p>Error loading product details: ${error.message}</p>
            <button onclick="this.closest('#custom-quick-view-modal').remove(); document.body.classList.remove('overflow-hidden');" 
                    class="quick-view-add-btn">Close</button>
          </div>
        `;
      });
  }

  function loadSwatchProduct(handle, container) {

    if (typeof window.plSwatches !== 'undefined' && window.plSwatches.init) {
      window.plSwatches.init(element);
      return;
    }
    
    // Show loading state
    const mainImage = container.querySelector('#qv-main-image');
    const originalSrc = mainImage ? mainImage.src : '';
    
    Promise.all([
      fetch(`/products/${handle}.js`).then(response => response.json()),
      fetch(`/products/${handle}`).then(response => response.text())
    ])
      .then(([product, htmlContent]) => {
        const firstVariant = product.variants[0];
        
        // Parse HTML to get fresh swatches and other data
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        
        // Update title
        const titleElement = container.querySelector('.quick-view-title');
        if (titleElement) {
          titleElement.textContent = product.title;
        }
        
        // Update price
        const priceElement = container.querySelector('.quick-view-price');
        if (priceElement) {
          priceElement.textContent = `£${(firstVariant.price / 100).toFixed(2)}`;
        }
        
        // Update swatches with fresh data
        const collectionSwatchesElement = doc.querySelector('[data-pl-swatches-collection]');
        const regularSwatchesElement = doc.querySelector('.pl-swatches');
        const quickViewSwatches = container.querySelector('.quick-view-swatches');
        
        if (quickViewSwatches) {
          if (collectionSwatchesElement) {
            quickViewSwatches.innerHTML = collectionSwatchesElement.outerHTML;
          } else if (regularSwatchesElement) {
            quickViewSwatches.innerHTML = regularSwatchesElement.outerHTML;
          }
          
          // Re-add swatch handlers
          const newSwatchLinks = quickViewSwatches.querySelectorAll('.pl-swatches__link, .pl-swatches-collection__link');
          newSwatchLinks.forEach(link => {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              
              const href = this.getAttribute('href');
              let newHandle = this.dataset.handle;
              
              if (!newHandle && href && href.startsWith('/products/')) {
                newHandle = href.replace('/products/', '');
              }
              
              if (newHandle && newHandle !== handle) {
                loadSwatchProduct(newHandle, container);
              }
              
              // Update active swatch
              const swatchContainer = this.closest('.pl-swatches__container, .pl-swatches-collection__container');
              if (swatchContainer) {
                const wrapperClass = this.classList.contains('pl-swatches__link') ? 
                  '.pl-swatches__swatch-wrapper' : '.pl-swatches-collection__swatch-wrapper';
                const activeClass = this.classList.contains('pl-swatches__link') ? 
                  'pl-swatches__swatch-wrapper--active' : 'pl-swatches-collection__swatch-wrapper--active';
                  
                swatchContainer.querySelectorAll(wrapperClass).forEach(wrapper => {
                  wrapper.classList.remove(activeClass);
                });
                this.querySelector(wrapperClass).classList.add(activeClass);
              }
            });
          });
        }
        
        // Update variant selects
        const variantSelectsElement = doc.querySelector('variant-selects');
        const quickViewVariants = container.querySelector('.quick-view-variant-select');
        if (variantSelectsElement && quickViewVariants) {
          const fieldsets = variantSelectsElement.querySelectorAll('fieldset');
          let variantSelectsHtml = '';
          
          fieldsets.forEach(fieldset => {
            const legend = fieldset.querySelector('legend');
            const inputs = fieldset.querySelectorAll('input[type="radio"]');
            if (legend && inputs.length > 0) {
              variantSelectsHtml += `
                <div class="variant-label">${legend.textContent}</div>
                <div class="variant-options">
                  ${Array.from(inputs).map(input => {
                    const label = fieldset.querySelector(`label[for="${input.id}"]`);
                    let labelText = input.value;
                    if (label) {
                      let cleanText = label.textContent || label.innerText || '';
                      cleanText = cleanText.replace(/Variant sold out or unavailable/gi, '');
                      cleanText = cleanText.replace(/\s+/g, ' ').trim();
                      labelText = cleanText && cleanText !== input.value ? cleanText : input.value;
                    }
                    return `
                      <input type="radio" id="qv-${input.id}" name="qv-${input.name}" value="${input.value}" ${input.checked ? 'checked' : ''}>
                      <label for="qv-${input.id}">${labelText}</label>
                    `;
                  }).join('')}
                </div>
              `;
            }
          });
          
          quickViewVariants.innerHTML = variantSelectsHtml;
          
          // Re-add variant handlers
          const newVariantRadios = quickViewVariants.querySelectorAll('input[type="radio"]');
          newVariantRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              const selectedOptions = Array.from(container.querySelectorAll('.variant-options input[type="radio"]:checked'))
                .map(input => input.value);
              
              const matchingVariant = product.variants.find(variant => {
                return selectedOptions.every(option => 
                  variant.option1 === option || variant.option2 === option || variant.option3 === option
                );
              });
              
              if (matchingVariant) {
                container.querySelector('#qv-variant-id').value = matchingVariant.id;
                container.querySelector('.quick-view-price').textContent = `£${(matchingVariant.price / 100).toFixed(2)}`;
              }
            });
          });
        }
        
        // Update images
        const mainImage = container.querySelector('#qv-main-image');
        const thumbnailsContainer = container.querySelector('.quick-view-thumbnails');
        
        if (product.images && product.images.length > 0) {
          if (mainImage) {
            mainImage.src = product.images[0];
          }
          
          if (thumbnailsContainer) {
            thumbnailsContainer.innerHTML = product.images.map((imageUrl, index) => `
              <div class="qv-thumbnail ${index === 0 ? 'active' : ''}" data-image="${imageUrl}">
                <img src="${imageUrl}" alt="${product.title}">
              </div>
            `).join('');
            
            // Re-add thumbnail click handlers
            const newThumbnails = thumbnailsContainer.querySelectorAll('.qv-thumbnail');
            newThumbnails.forEach(thumbnail => {
              thumbnail.addEventListener('click', function() {
                const imageUrl = this.dataset.image;
                if (mainImage && imageUrl) {
                  mainImage.src = imageUrl;
                  newThumbnails.forEach(t => t.classList.remove('active'));
                  this.classList.add('active');
                }
              });
            });
          }
        }
        
        // Update variant ID for cart
        const variantIdInput = container.querySelector('#qv-variant-id');
        if (variantIdInput) {
          variantIdInput.value = firstVariant.id;
        }
      })
      .catch(error => {
        console.error('Error loading swatch product:', error);
        // Restore original image on error
        if (mainImage && originalSrc) {
          mainImage.src = originalSrc;
        }
      });
  }

  function updateQty(btn, change) {
    const input = btn.parentElement.querySelector('input[name="quantity"]');
    let qty = parseInt(input.value) + change;
    input.value = qty < 1 ? 1 : qty;
  }

  function initializeEssenceQuiz() {
    document.body.classList.add('essence-quiz-page');
    const quiz = new EssenceQuiz();
    window.essenceQuiz = quiz;
    quiz.init();
  }

  window.addEventListener('beforeunload', function() {
      if (window.essenceQuiz && window.essenceQuiz.quizStarted && window.essenceQuiz.currentQuizStep < 9) {
          window.sendQuizCompletionToKlaviyo({
              quiz_result: `abandoned at step ${window.essenceQuiz.currentQuizStep}`,
              step: window.essenceQuiz.currentQuizStep,
              quiz_completion: `abandoned_step_${window.essenceQuiz.currentQuizStep}`,
              quiz_last_step: window.essenceQuiz.currentQuizStep
          });
      }
  });

  document.addEventListener('click', function(e) {

    const quickViewLink = e.target.closest('.open-quick-view');
    if (quickViewLink) {
      e.preventDefault();
      openQuickView(quickViewLink.getAttribute('href'));
      return;
    }
    
    const swatchLink = e.target.closest('.pl-swatches-collection__link');
    if (swatchLink && swatchLink.closest('.slider-product-card')) {
      e.preventDefault();
      
      const container = swatchLink.closest('.pl-swatches-collection__container');
      container.querySelectorAll('.pl-swatches-collection__swatch-wrapper').forEach(wrapper => {
        wrapper.classList.remove('pl-swatches-collection__swatch-wrapper--active');
      });
      
      swatchLink.querySelector('.pl-swatches-collection__swatch-wrapper').classList.add('pl-swatches-collection__swatch-wrapper--active');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEssenceQuiz);
    } else {
      initializeEssenceQuiz();
  }

  let lastScrollY = 0;
  let isHeaderHidden = false;
  let isProgressHidden = false;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    const header = document.querySelector('sticky-header.header-wrapper');
    const progress = document.querySelector('.quiz-progress');
    const isCompleted = progress && progress.querySelector('.quiz-progress-text').textContent === 'COMPLETED';
    
    if (!header) return;
    
    if (currentScrollY > 120) {
      if (currentScrollY > lastScrollY && !isHeaderHidden) {
        header.style.transform = 'translateY(-100%)';
        header.style.transition = 'transform 0.3s ease';
        isHeaderHidden = true;
      } else if (currentScrollY < lastScrollY && isHeaderHidden) {
        header.style.transform = 'translateY(0)';
        isHeaderHidden = false;
      }
      
      if (progress && isCompleted && currentScrollY > lastScrollY && !isProgressHidden) {
        progress.style.transform = 'translateY(100%)';
        progress.style.transition = 'transform 0.3s ease';
        isProgressHidden = true;
      } else if (progress && isCompleted && currentScrollY < lastScrollY && isProgressHidden) {
        progress.style.transform = 'translateY(0)';
        isProgressHidden = false;
      }
    } else {
      header.style.transform = 'translateY(0)';
      isHeaderHidden = false;
      
      if (progress) {
        progress.style.transform = 'translateY(0)';
        isProgressHidden = false;
      }
    }
    
    lastScrollY = currentScrollY;
  });

  window.addEventListener('resize', () => {
      const isDualResult = document.querySelector('.dual-essence-result');
      if (!isDualResult) return;
      
      const leftEssenceName = document.querySelector('.left-column .essence-name');
      const rightEssenceName = document.querySelector('.right-column .essence-name');
      
      if (leftEssenceName && leftEssenceName.textContent.includes('TIMELESS GRACE')) {
        leftEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      }
      
      if (rightEssenceName && rightEssenceName.textContent.includes('TIMELESS GRACE')) {
        rightEssenceName.style.fontSize = window.innerWidth <= 768 ? '36px' : '130px';
      }
    
    });

    document.addEventListener('DOMContentLoaded', function () {
    const startButton = document.querySelector('.quiz-start');
    
    if (startButton) {
      startButton.addEventListener('click', function(event) {
        event.preventDefault();
        
        document.querySelectorAll('.quiz-step').forEach(div => div.classList.add('hidden'));
        document.querySelector('.quiz-step[data-step="2"]')?.classList.remove('hidden');
        

        if (window.essenceQuiz) {
          window.essenceQuiz.currentStep = 2;
          window.essenceQuiz.updateProgress();
        }

        if (window.essenceQuiz && window.essenceQuiz.analytics) {
          window.dataLayer.push({
            'event': 'quiz_start_button_clicked',
            'event_category': 'Quiz_Engagement', 
            'event_label': 'Start_Button',
            'quiz_session_id': window.essenceQuiz.analytics.sessionId
          });
        }
        
        try {
          window.sendQuizCompletionToKlaviyo({
            quiz_result: '',
            step: 'start',
            quiz_completion: 'started',
            quiz_last_step: 1
          });
        } catch (error) {
          console.error('Klaviyo error:', error);
        }
      });
    }
  });

  window.sendQuizCompletionToKlaviyo = function (quizResults) {
    if (!window.quizUserData) {
        console.error('No user data found for Klaviyo submission');
        return;
    }

    if (quizResults.try_pass_expires_at) {
      quizResults.try_pass_expires_at =
        window.formatKlaviyoDate(quizResults.try_pass_expires_at);
    }

    const userData = window.quizUserData;

    const isCompleted = quizResults.quiz_completion === 'completed';
      
      try {

          klaviyo.identify({
              'email': userData.email,
              '$first_name': userData.firstName,
              '$last_name': userData.lastName || '',
              'quiz_completed': isCompleted, 
              'quiz_completion_date': isCompleted ? new Date().toISOString() : null, 
              'quiz_result': quizResults.quiz_result || '',
              'quiz_result_primary': quizResults.quiz_result_primary || '',
              'quiz_result_secondary': quizResults.quiz_result_secondary || '',
              'essence_combination': quizResults.essence_combination || '',
              'quiz_completion': quizResults.quiz_completion || 'started',
              'quiz_last_step': quizResults.quiz_last_step || 1,
              'real_confidence_percentage': quizResults.real_confidence_percentage || 0,
              'real_passion_percentage': quizResults.real_passion_percentage || 0,
              'real_timeless_percentage': quizResults.real_timeless_percentage || 0,
              'real_serenity_percentage': quizResults.real_serenity_percentage || 0,
              'try_pass_code': quizResults.try_pass_code || '',
              'try_pass_expires_at': quizResults.try_pass_expires_at || ''
          });
          
          klaviyo.track('Quiz Completed', {
              'quiz_name': 'ESSENCE MATCH QUIZ',
              'email': userData.email,
              'first_name': userData.firstName,
              'quiz_results': JSON.stringify(quizResults),
              'completion_date': new Date().toISOString(),
              'real_confidence_percentage': quizResults.real_confidence_percentage || 0,
              'real_passion_percentage': quizResults.real_passion_percentage || 0,
              'real_timeless_percentage': quizResults.real_timeless_percentage || 0,
              'real_serenity_percentage': quizResults.real_serenity_percentage || 0,
              'try_pass_code': quizResults.try_pass_code || '',
              'try_pass_expires_at': quizResults.try_pass_expires_at || ''
          });

          const subscriptionData = {
              "g": "Vyjm58", 
              "email": userData.email,
              "$fields": "$first_name,$last_name,quiz_completed,quiz_result,quiz_result_primary,quiz_result_secondary,essence_combination,quiz_completion,quiz_last_step,real_confidence_percentage,real_passion_percentage,real_timeless_percentage,real_serenity_percentage,try_pass_code,try_pass_expires_at",
              "$first_name": userData.firstName,
              "$last_name": userData.lastName || '',
              "quiz_completed": isCompleted, 
              "quiz_result": quizResults.quiz_result || '',
              "quiz_result_primary": quizResults.quiz_result_primary || '',
              "quiz_result_secondary": quizResults.quiz_result_secondary || '',
              "essence_combination": quizResults.essence_combination || '',
              "quiz_completion": quizResults.quiz_completion || 'started',
              "quiz_last_step": quizResults.quiz_last_step || 1,
              "$source": "Essence Quiz",
              "real_confidence_percentage": quizResults.real_confidence_percentage || 0,
              "real_passion_percentage": quizResults.real_passion_percentage || 0,
              "real_timeless_percentage": quizResults.real_timeless_percentage || 0,
              "real_serenity_percentage": quizResults.real_serenity_percentage || 0,
              "try_pass_code": quizResults.try_pass_code || '',
              "try_pass_expires_at": quizResults.try_pass_expires_at || ''
          };

          if (typeof $ !== 'undefined') {
            
              $.ajax({
                  "async": true,
                  "crossDomain": true,
                  "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                  "method": "POST",
                  "headers": {
                      "content-type": "application/x-www-form-urlencoded",
                      "cache-control": "no-cache"
                  },
                  "data": subscriptionData
              }).fail(function (error) {
                  console.error('AJAX subscription failed:', error);
              });
          } else {
              const formData = new URLSearchParams(subscriptionData);
              
              fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                      'Cache-Control': 'no-cache'
                  },
                  body: formData
              }).then(response => {
                  if (response.ok) {

                  } 
              }).catch(error => {
                  console.error('Fetch error:', error);
              });
          }

      } catch (error) {
          
          try {
              klaviyo.identify({'email': userData.email});
              klaviyo.track('Quiz Completed Fallback', {
                  'email': userData.email,
                  'quiz_results': JSON.stringify(quizResults)
              });
          } catch (fallbackError) {
              console.error('Fallback method also failed:', fallbackError);
          }
      }
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (
      document.body.classList.contains('essence-quiz-page') &&
      document.body.classList.contains('quiz-completed')
    ) {
      const span = document.querySelector('.announcement-bar__message span');
      const utilityBar = document.querySelector('.utility-bar');
      
      if (span && utilityBar) {
        span.innerHTML = `£20 OFF with <a href="#" id="copyEssenceCode" style="cursor: pointer;"><span class="discount_code_essence">ESSENCE20</span><span id="copyIcon">📋</span></a> on orders £70+`;

        const icon = document.getElementById('copyIcon');

        utilityBar.addEventListener('click', function (e) {
          navigator.clipboard.writeText('ESSENCE20').then(() => {
            if (icon) {
              icon.textContent = '✅';
              setTimeout(() => {
                icon.textContent = '📋';
              }, 2000);
            }
          });
        });
      }
    }
  });

  function startScrollDepthTracking() {
    let ticking = false;
    
    function updateScrollDepth() {
      const scrolled = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const percentage = Math.round((scrolled / maxScroll) * 100);
      
      if (window.essenceQuiz && window.essenceQuiz.analytics) {
        window.essenceQuiz.analytics.trackScrollDepth(percentage);
      }
      
      ticking = false;
    }
    
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateScrollDepth);
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick);
  }

  function setupProductViewTracking() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const productId = card.dataset.productId;
          const productTitle = card.dataset.productTitle;
          const essence = card.dataset.essence;
          const position = card.dataset.position;
          
          if (window.essenceQuiz && window.essenceQuiz.analytics && productId) {
            window.essenceQuiz.analytics.trackProductView(productId, productTitle, essence, position);
          }
        }
      });
    }, { threshold: 0.5 });
    
    document.querySelectorAll('.slider-product-card').forEach(card => {
      observer.observe(card);
    });
  }

  window.openQuickViewWithTracking = function(productUrl, productId, productTitle, essence) {
    if (window.essenceQuiz && window.essenceQuiz.analytics) {
      window.essenceQuiz.analytics.trackQuickView(productId, productTitle, essence);
    }
    
    openQuickView(productUrl);
  };

  window.trackAddToCartClick = function(productId, productTitle, essence, price) {
    if (window.essenceQuiz && window.essenceQuiz.analytics) {
      window.essenceQuiz.analytics.trackAddToCart(productId, productTitle, essence, price);
    }
  };

  function startTryPassCountdown(timerEl, endsAtISO) {
    function tick() {
      const left = new Date(endsAtISO).getTime() - Date.now();
      timerEl.textContent = formatHMS(left);
      if (left > 0) setTimeout(tick, 500);
    }
    tick();
  }

  function copyTextToClipboard(text, onDone) {
    navigator.clipboard.writeText(text).then(() => {
      if (typeof onDone === 'function') onDone();
    }).catch(() => {});
  }

  function pad2(n){ return String(n).padStart(2,'0'); }

  function formatHMS(ms){
    if (ms <= 0) return '00:00:00';
    const h = Math.floor(ms / 3.6e6),
          m = Math.floor((ms % 3.6e6) / 6e4),
          s = Math.floor((ms % 6e4) / 1e3);
    return `${pad2(h)}:${pad2(m)}:${pad2(s)}`;
  }

  function sleep(ms){ return new Promise(r=>setTimeout(r, ms)); }

  window.__tryPassCode && sessionStorage.setItem('tryPassCode', window.__tryPassCode);


  (function () {
    const root = document.querySelector('.capsule-pass[data-tp]');
    if (!root) return;

    const code = (window.__tryPassCode) ||
                (window.tryPassData && window.tryPassData.code) ||
                null;

    const codeEl = root.querySelector('#capsule-pass-code');

    if (codeEl) {
      if (code) {
        codeEl.textContent = code;
        codeEl.setAttribute('data-try-pass-code', code);
      }
      codeEl.addEventListener('click', async () => {
        const val = codeEl.getAttribute('data-try-pass-code') || codeEl.textContent.trim();
        if (!val) return;
        try { await navigator.clipboard.writeText(val); } catch {}
        const prev = codeEl.textContent;
        codeEl.textContent = 'Copied!';
        setTimeout(() => { codeEl.textContent = prev; }, 2000);
      });
    }

    let color =
      (typeof window.getEssenceColor === 'function' && window.getEssenceColor(window.primaryEssence)) ||
      window.currentEssenceColor ||
      document.body.getAttribute('data-essence-color') ||
      null;

    if (color) root.style.setProperty('--tp-color', color);

    const btn = root.querySelector('#capsule-pass-btn');
    btn?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!code) return;

      try { await navigator.clipboard.writeText(code); } catch {}

      if (typeof window.applyDiscountCodeFromTryPass === 'function') {
        console.log('[TRY PASS] apply from capsule block', { code });
        window.applyDiscountCodeFromTryPass(code, { open: false, noRedirect: true });
      } else if (typeof window.applyPromoCodeAjax === 'function') {
        const ok = await window.applyPromoCodeAjax(code);
        if (ok && typeof window.refreshDrawerHtml === 'function') {
          await window.refreshDrawerHtml();
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        }
      }
    });
  })();


  (function () {
    let currentTryPassCode = '';

    function setCapsuleCodeDisplay(code) {
      const codeEl = document.getElementById('capsule-pass-code');
      if (codeEl) codeEl.textContent = code;
      document.querySelectorAll('.capsule-pass__code, .capsule-pass__cta')
        .forEach(el => el.setAttribute('data-try-pass-code', code));
    }

    document.addEventListener('trypass:ready', (e) => {
      const code = e?.detail?.code || '';
      if (!code) return;
      currentTryPassCode = code;
      window.__tryPassCode = code; // optional, if other code relies on it
      setCapsuleCodeDisplay(code);
      document.querySelectorAll('.try-pass__code').forEach(el => el.textContent = code);
      document.querySelectorAll('.try-pass__cta, .try-pass__card, .try-pass__code')
        .forEach(el => el.setAttribute('data-try-pass-code', code));
      console.log('[TRY PASS] event trypass:ready', { code });
    });

    // One delegated click handler for both blocks
    document.addEventListener('click', (e) => {
      const hit = e.target.closest(
        '.try-pass__cta, .try-pass__card, .try-pass__code, .capsule-pass__cta, .capsule-pass__code'
      );
      if (!hit) return;

      e.preventDefault();
      e.stopPropagation();

      const code =
        hit.getAttribute('data-try-pass-code') ||
        currentTryPassCode ||
        document.querySelector('.try-pass__code')?.textContent?.trim() ||
        document.getElementById('capsule-pass-code')?.textContent?.trim() ||
        '';

      if (!code || /—/.test(code)) {
        console.warn('[TRY PASS] no code ready yet');
        return;
      }

      navigator.clipboard.writeText(code)
        .then(() => console.log('[TRY PASS] clipboard OK', code))
        .catch(() => {})
        .finally(() => {
          const help =
            document.querySelector('.capsule-pass__help') ||
            document.querySelector('.try-pass__help');
          if (help) {
            const prev = help.textContent;
            help.textContent = 'Copied ✓';
            setTimeout(() => { help.textContent = prev; }, 1200);
          }
        });

    });
  })();


(() => {
  const btn = document.querySelector('#capsule-pass-btn');
  const target = document.getElementById('essence-products-container');
  if (!btn || !target) return;

  btn.addEventListener('click', () => {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, { passive: true });
})();


(() => {
  const btn = document.querySelector('.try-pass__cta');
  const target = document.getElementById('essence-products-container');
  if (!btn || !target) return;

  btn.addEventListener('click', (e) => {
    if (!e.isTrusted) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    e.preventDefault();
    e.stopPropagation();

    setTimeout(() => {
      const ev = new MouseEvent('click', { bubbles: true, cancelable: true });
      btn.dispatchEvent(ev);
    }, 500);
  }, { capture: true });
})();


window.formatKlaviyoDate = function (input) {
  const d = new Date(input);
  if (isNaN(d)) return input;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = String(d.getFullYear()).slice(-2);
  const HH = String(d.getHours()).padStart(2, '0');
  const MM = String(d.getMinutes()).padStart(2, '0');
  return `${dd}-${mm}-${yy} ${HH}:${MM}`;
};


(function () {
  function addParamToUrl(flag) {
    if (location.search && new URLSearchParams(location.search).has(flag)) return;
    const sep = location.search ? '&' : '?';
    const newUrl = location.pathname + location.search + sep + encodeURIComponent(flag) + location.hash;
    history.pushState({}, '', newUrl);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quiz-step[data-step="10"] .quiz-next');
    if (!btn) return;
    addParamToUrl('quiz-completed');  
  });
})();


(function(){
  window.dataLayer = window.dataLayer || [];
  function sid(){ return (window.essenceQuiz&&window.essenceQuiz.analytics&&window.essenceQuiz.analytics.sessionId)||null; }

  var section = document.querySelector('.try-pass');
  if (section) {
    var sent=false;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!sent && e.isIntersecting && e.intersectionRatio>=0.5){
          window.dataLayer.push({
            event:'section_view',
            section_name:'try_pass',
            visibility:'50_plus',
            quiz_session_id:sid()
          });
          sent=true;
        }
      });
    },{threshold:[0,0.25,0.5,0.75,1]});
    io.observe(section);
  }

  var origCopy = window.copyTextToClipboard;
  window.copyTextToClipboard = function(text, onDone){
    if (typeof navigator!=='undefined' && navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(text).then(function(){
        window.dataLayer.push({
          event:'promo_code_copied',
          promo_code:String(text||'').trim(),
          source:'programmatic',
          quiz_session_id:sid()
        });
        if (typeof onDone==='function') onDone();
      }).catch(function(){});
    } else if (typeof origCopy==='function'){
      origCopy(text, onDone);
    }
  };

  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-try-pass-code]');
    if (!el) return;
    var code = el.getAttribute('data-try-pass-code') || (el.textContent||'').trim();
    if (!code) return;
    window.copyTextToClipboard(code, function(){
      window.dataLayer.push({
        event:'promo_code_copied',
        promo_code:code,
        source:(el.tagName||'').toLowerCase(),
        quiz_session_id:sid()
      });
      var help = el.closest('.try-pass__card') && el.closest('.try-pass__card').querySelector('.try-pass__help');
      if (help) help.classList.add('visible');
    });
  });
})();

